import React, { Component } from "react";
import axios from "axios";
import { APIURL, PORT } from "../../../config/config"; // PORT
import DatePicker from "react-datepicker";
import { differenceInDays, format } from "date-fns"; //  parse, isValid, format,
import moment from "moment";
import NumberFormat from "react-number-format";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import ThaiBaht from "thai-baht-text";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { LineNotify } from "../../../config/lineNotify";
import { NumberUtil } from "../../../utils/number-util";
import AgentModal from "../../Agent/AgentModal";
import ReactQuill from "react-quill";
import { AlertError, AlertWarning } from "../../Alert/Alert";
import {
  checkFormControls,
  checkGroupPermission,
  getFormControlName,
  getGroupPermission,
} from "../../../services/grouppermission";
import {
  getCompanySetting,
  getDocTypeConfig,
  getVatBathIncludeVat,
  getVatBathFromAmount,
} from "../../../services/companysetting";
import Switch from "react-switch";
import CustomerForm from "../../Customer/CustomerForm";
import { Button, Modal, ModalBody } from "reactstrap";
import {
  checkDocNo,
  setInputStyleDocNo,
} from "../../../services/docLogService";
import SelectSearch from "react-select-search";
import { DateUtil } from "../../../utils/dateUtil";
import { MonthUtil } from "../../../utils/monthUtil";
import PreviewImage from "../../../views/PreviewImage";
import { PDFUtil } from "../../../utils/pdfUtil";

pdfMake.vfs = pdfFonts;
pdfMake.fonts = PDFUtil.getCustomFonts();

const port = Number(window.env.PORT);

class SalesBuy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuID: [801, 802, 803, 806],
      grouppermissions: [],
      user: {},
      lists: [],
      load_data: true,
      car: "",
      bank: [],
      car_sell_type: [],
      insurance_company: [],
      insurance_type: [],
      count_period: [],
      duration_period: [],
      customer_list: [],
      car_sell_list_pay: [],
      car_status: [],
      customer_select: false,
      sales_type: [],
      car_id: "",
      customer_id: "",
      customer: {},
      real_sell_price: 0,
      normal_sell_price: 0,
      car_sell_discount: 0,
      rate_finance: 0,
      insurance_pa: 0,
      tax_rate_finance: 0,
      total_rate_finance: 0,
      sum_down: 0,
      insurance_price: 0,
      cost_finance: 0,
      cost_transfer: 0,
      cost_period_month: 0,
      total_cost_period_call: 0,
      total_outof_car: 0,
      balance_debt: 0,
      startDatePromise: new Date(), //moment(),
      car_sell_pay: [],
      startDatePaySell: new Date(), //moment(),
      car_sell_pay_count: 0,
      count_period_id: 0,
      car_sell_pay_list: [],
      car_sell_type_id: "",
      car_pay_all: 0,
      insurance_buy: "ประกันแถม",
      /*promotion_list: [
        {promotion_id: 1, promotion_name: 'ส่วนลด1หมื่น' },
        {promotion_id: 2, promotion_name: '1แถม1' },
        {promotion_id: 3, promotion_name: 'จ่าย2ขับ4' },
        {promotion_id: 4, promotion_name: 'ช่วยค่างวด1ปี' },
        {promotion_id: 5, promotion_name: 'ขับฟรีถึงปีใหม่' },
        {promotion_id: 6, promotion_name: 'ของแถมยกเซ็ต12รายการ' },
        {promotion_id: 7, promotion_name: 'แถมช่วยเหลือฉุกเฉิน smart sure' },
        {promotion_id: 8, promotion_name: 'แถมประกันเครื่องเกียร์ Fixman' },
        {promotion_id: 9, promotion_name: 'โปรโมชั่นช่วยผ่อน 1,000 บาท 12 เดือน' },
        {promotion_id: 10, promotion_name: 'โปรโมชั่นช่วยผ่อน 2,000 บาท 12 เดือน' },
        {promotion_id: 11, promotion_name: 'โปรโมชั่นช่วยผ่อน 3,000 บาท 12 เดือน' },
        {promotion_id: 12, promotion_name: 'โปรโมชั่นช่วยผ่อน 4,000 บาท 12 เดือน' },
        {promotion_id: 13, promotion_name: 'โปรโมชั่นช่วยผ่อน 5,000 บาท 12 เดือน' },
        {promotion_id: 14, promotion_name: 'โปรโมชั่นส่วนลด 10,000 บาท' },
        {promotion_id: 15, promotion_name: 'โปรโมชั่นส่วนลด 20,000 บาท' },
        {promotion_id: 16, promotion_name: 'โปรโมชั่นส่วนลด 30,000 บาท' },
        {promotion_id: 17, promotion_name: 'โปรโมชั่นส่วนลด 40,000 บาท' },
        {promotion_id: 18, promotion_name: 'โปรโมชั่นส่วนลด 50,000 บาท' },
        {promotion_id: 19, promotion_name: 'โปรโมชั่นส่วนลดพิเศษ' }
      ],*/
      promotion_list: [],
      gearbox_warranty_list: [
        {
          gearbox_warranty_id: 1,
          gearbox_warranty_name: "ไม่รับประกันเครื่องเกียร์",
        },
        {
          gearbox_warranty_id: 2,
          gearbox_warranty_name: "รับประกันเครื่องเกียร์",
        },
      ],
      gearbox_bank_name: "", // ธนาคารที่รับประกันเครื่องเกียร์
      gearbox_warranty: "", // 1.ไม่รับประกันเครื่องเกียร์ / 2.รับประกันเครื่องเกียร์
      gearbox_amount: 0, // ยอดประกันเครื่องเกียร์
      debt_insurance_amount: 0, // ยอดประกันภาระหนี้

      car_over_sales: 0, // ยอดขายเกิน
      car_excess_amount: 0, // ยอดจัดเกิน
      customer_cash: 0, // เงินคืนลูกค้า

      vat_sell: 0, // vat ขาย รายรับ
      finance_commission: 0, // ค่าคอมมิชชั่นไฟแนนท์ รายรับ
      vat_commission: 0, // ค่า vat คอมมิชชั่น รายรับ
      tax_invoice_amount: 0, // ยอดจัด-ใบกำกับ
      tax_invoice_vat: 0, // VAT ของยอดจัด-ใบกำกับ
      // รายจ่ายเพิ่ม
      car_external_commission: 0, // ค่านายหน้า ภายนอก
      sales_commission: 0, // ค่าคอมมิชชั่นฝ่ายขาย
      additional_commission: 0, // ค่าคอมมิชชั่นเพิ่มเติม
      advertising_cost: 0, // ค่าโฆษณา
      delivery_fee: 0, // ค่าบริการส่งรถ
      promotion_fee: 0, // ค่าโปรโมชั่น
      finance_fee: 0, // ค่าธรรมเนียมไฟแนนท์
      transfer_fee: 0, // ค่าโอนรถ
      // pisan
      monthly_installment: 0,
      total_installment: 0,
      first_installment: null,
      interest_installment: 0,
      car_issue_date: new Date(),
      liciense_status_id: 0,
      car_transfer_date: null,
      finance_payment_date: null,
      //
      agent_id: "",
      isAgentModal: false,
      agentSelected: null,
      sale_by_id: "",
      employees: [],
      pay_advance_finance: 0, // เก็บค่างวดรถล่วงหน้า
      sell_discount: 0, // ส่วนลดเงินดาวน์
      sell_finance_contract: "", // ชื่อพนักงานไฟแนนซ์
      sell_comment: "",
      width: 0,
      height: 0,
      is_insurance_pa: port === 9005 ? 1 : 0,
      //
      company_setting: null,
      doc_type: "",
      doc_config: "",
      is_vat: 0,
      include_vat: 0,
      doc_no: "",
      cost_phra: 0,
      cost_vat_and_property_tax: 0,
      banks: [],
      vat_down: 0,
      vat: 0,
      is_key_vat_down: port === 9043 ? true : false,
      //familyCar
      more_detail: [],
      //more_detail_id : 0
      form_controls: [],
      cost_after_sales_service: 0,
      finance_pa: 0,
      finance_car_insurance: 0,
      finance_ew: 0,
      finance_pay_advance: 0,
      finance_health_insurance: 0,
      finance_document_fee: 0,
      finance_transfer_fee: 0,
      finance_stamp_fee: 0,

      //ta--sc
      isAddCustomerNewModal: false,

      vatPercent: null,
      check_doc_no: "",
      tax_commission_amount: 0,
      tax_commission_vat: 0,
      total_outof_discount: 0,
      sum_pay: 0,
      refund_type: 0,
      refund_inpart: 0,
      insurance_pa_buy: "PA ซื้อเอง",
      is_no_commission: 0, // 0 =  ไม่ระบุ , 1 = ไม่มี com
      cost_sell_act: 0, // ค่า พรบ.
      sum_car_books: 0, // รวมเงินจอง
      profile_from: "",
      receipt_type: "ออกใบเสร็จรับเงิน",
      date_pay: new Date(),
      liciense_status: [],
      preview_image_select: false,
      preview_image_url: "",
    };

    this.handleDatePromise = this.handleDatePromise.bind(this);
    this.handleDatePaySell = this.handleDatePaySell.bind(this);
    this.onInsuranceBuyChanged = this.onInsuranceBuyChanged.bind(this);
    //this.addCarSellPay      = this.addCarSellPay.bind(this)
    this.handleCarIssueDate = this.handleCarIssueDate.bind(this);
    this.handleFistInstallmentDate = this.handleFistInstallmentDate.bind(this);
    this.handleOnSubmitSell = this.handleOnSubmitSell.bind(this);
    this.handleCarDateTransfer = this.handleCarDateTransfer.bind(this);
    this.handleFinancePaymentDate = this.handleFinancePaymentDate.bind(this);
    this.toggleAgentModal = this.toggleAgentModal.bind(this);
    this.loadEmployeeData = this.loadEmployeeData.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.loadGroupPermission = this.loadGroupPermission.bind(this);
    this.loadCompanySetting = this.loadCompanySetting.bind(this);
    this.clearFormCarSellPay = this.clearFormCarSellPay.bind(this);
    this.printOcpb = this.printOcpb.bind(this);
    this.loadBankDataIsBank = this.loadBankDataIsBank.bind(this);
    this.loadFormControls = this.loadFormControls.bind(this);
    this.renderInput = this.renderInput.bind(this);
    // ta--sc
    this.toggleAddCustomerNewModal = this.toggleAddCustomerNewModal.bind(this);
    this.toggleAddCustomer = this.toggleAddCustomer.bind(this);
    this.resetCustomerSelect = this.resetCustomerSelect.bind(this);

    this.renderInputWithCalVatFinance =
      this.renderInputWithCalVatFinance.bind(this);
    this.renderInputWithCalVatCommission =
      this.renderInputWithCalVatCommission.bind(this);
    this.checkTaxInvoiceNumberRepeat =
      this.checkTaxInvoiceNumberRepeat.bind(this);
    this.calTotalOutOfCarWithDiscount =
      this.calTotalOutOfCarWithDiscount.bind(this);

    this.onInsurancePABuyChanged = this.onInsurancePABuyChanged.bind(this);
    this.loadProfile = this.loadProfile.bind(this);
    this.loadPromotionData = this.loadPromotionData.bind(this);

    this.toggleCarSellPayAdd = this.toggleCarSellPayAdd.bind(this);
    this.carSellPayAdd = this.carSellPayAdd.bind(this);
    this.handleCarSellPayAddSubmit = this.handleCarSellPayAddSubmit.bind(this);
    this.handleDatePay = this.handleDatePay.bind(this);
    //this.onRefundTypeChange = this.onRefundTypeChange.bind(this)
    this.loadLicienseStatus = this.loadLicienseStatus.bind(this);
    this.onPreviewSelected = this.onPreviewSelected.bind(this);
    this.togglePreviewImage = this.togglePreviewImage.bind(this);
  }

  async loadCompanySetting() {
    const company_setting = await getCompanySetting();
    const is_vat = company_setting.is_vat;

    //const doc_type = is_vat === 1 ? 'RT' : 'RE'
    const doc_type = "RE";
    const receipt_type =
      doc_type === "RT" ? "ออกใบกำกับภาษี" : "ออกใบเสร็จรับเงิน";
    const doc_config = getDocTypeConfig(company_setting, doc_type);

    // include_vat: 0
    // ถ้า is_vat = 1
    // include_vat = 0  => ยอดรวม vat = car_sell_pay_count + vat_bath
    // include_vat = 1  => ยอดรวม vat = car_sell_pay_count

    const include_vat = is_vat === 1 ? 1 : 0;
    const vat = is_vat === 1 ? company_setting.vat : 0;
    const vatPercent = is_vat === 1 ? company_setting.vat / 100.0 : 0;

    this.setState({
      company_setting: company_setting,
      doc_type: doc_type,
      doc_config: doc_config,
      is_vat: is_vat,
      vat: vat,
      include_vat: include_vat,
      vatPercent,
      receipt_type: receipt_type,
    });
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  handleDatePaySell(date) {
    this.setState({
      startDatePaySell: date,
    });
  }

  loadBankData() {
    // axios.get(APIURL + '/bank/')
    axios
      .get(APIURL + "/bank/get/is_leasing")
      .then((res) => {
        this.setState({ bank: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ bank: [] });
      });
  }

  loadBankDataIsBank() {
    axios
      .get(APIURL + "/bank/get/is_banks")
      .then((res) => {
        this.setState({ banks: res.data });
      })
      .catch((error) => {
        this.setState({
          banks: [],
          is_banks: 1,
        });
      });
  }

  loadSalesTypeData() {
    axios
      .get(APIURL + "/sales_type/")
      .then((res) => {
        this.setState({ sales_type: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ sales_type: [] });
      });
  }

  loadCarSellTypeData() {
    axios
      .get(APIURL + "/car_sell_type/")
      .then((res) => {
        this.setState({ car_sell_type: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ car_sell_type: [] });
      });
  }

  loadInsuranceCompanyData() {
    axios
      .get(APIURL + "/insurance_company/")
      .then((res) => {
        this.setState({ insurance_company: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ insurance_company: [] });
      });
  }

  loadInsuranceTypeData() {
    axios
      .get(APIURL + "/insurance_type/")
      .then((res) => {
        this.setState({ insurance_type: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ insurance_type: [] });
      });
  }

  loadCountPeriodData() {
    axios
      .get(APIURL + "/count_period/")
      .then((res) => {
        this.setState({ count_period: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ count_period: [] });
      });
  }

  loadDurationPeriodData() {
    axios
      .get(APIURL + "/duration_period/")
      .then((res) => {
        this.setState({ duration_period: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ duration_period: [] });
      });
  }

  loadCarSellListPayData() {
    axios
      .get(APIURL + "/car_sell_list_pay/")
      .then((res) => {
        this.setState({ car_sell_list_pay: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ car_sell_list_pay: [] });
      });
  }

  loadCarStatusData() {
    axios
      .get(APIURL + "/car_status/sell/1")
      .then((res) => {
        this.setState({ car_status: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        console.log("error:", error);
        this.setState({ car_status: [] });
      });
  }

  loadMoreDetailData() {
    axios
      .get(APIURL + "/more_detail/")
      .then((res) => {
        this.setState({ more_detail: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ more_detail: [] });
      });
  }

  loadPromotionData() {
    axios
      .get(APIURL + "/promotion/")
      .then((res) => {
        this.setState({ promotion_list: res.data });
        //alert (res.data)
      })
      .catch((error) => {
        this.setState({ promotion_list: [] });
      });
  }

  loadLicienseStatus() {
    axios
      .get(APIURL + "/liciense_status/")
      .then((res) => {
        this.setState({ liciense_status: res.data });
      })
      .catch((error) => {
        this.setState({ liciense_status: [] });
      });
  }

  handleDatePromise(date) {
    this.setState({
      startDatePromise: date,
    });
  }

  handleCarIssueDate(date) {
    this.setState({
      car_issue_date: date,
    });
  }

  //
  handleFistInstallmentDate(date) {
    this.setState({
      first_installment: date,
    });
  }

  handleCarDateTransfer(date) {
    this.setState({
      car_transfer_date: date,
    });
  }

  handleFinancePaymentDate(date) {
    this.setState({
      finance_payment_date: date,
    });
  }

  handleDatePay(date) {
    this.setState({
      date_pay: date,
    });
  }

  async carSellPayAdd() {
    // 9043 ปิดการขายแล้ว แต่ยังรับชำระเงินได้
    // if(this.state.sell_status==='close') {
    //   AlertError('ไม่สามารถเพิ่มการชำระเงินได้ ได้เนื่องจากปิดการขายแล้ว');
    //   return
    // }

    await this.loadSalesTypeData();
    await this.loadBankData();
    await this.loadBankDataIsBank();

    await axios
      .get(APIURL + "/car_sell_list_pay/")
      .then((res) => {
        if (this.mounted) {
          this.setState(
            {
              car_sell_list_pay: res.data,
              date_pay: new Date(),
              car_sell_list_pay_id: 0,
              car_sell_pay_count: 0,
              sales_type_id: 0,
              bank_id: 0,
            },
            () => {
              this.toggleCarSellPayAdd();
            }
          );
        }
      })
      .catch((error) => {
        if (this.mounted) {
          this.setState({ car_sell_list_pay: [] });
        }
      });
  }

  toggleCarSellPayAdd() {
    this.setState({
      toggle_pay_add: !this.state.toggle_pay_add,
    });
  }

  onPreviewSelected(url) {
    this.setState({
      preview_image_url: url,
      preview_image_select: true,
    });
  }

  togglePreviewImage() {
    this.setState({
      preview_image_select: !this.state.preview_image_select,
    });
  }

  handleOnSubmitSell(event) {
    event.preventDefault();

    let car_id = this.state.car_id;
    let customer_id = this.state.customer_id;
    let car_sell_type_id = event.target.car_sell_type_id.value;
    let insurance_company_id =
      event.target.insurance_company_id.value === ""
        ? 99
        : event.target.insurance_company_id.value;
    // 99 ไม่ระบุ event.target.insurance_company_id.value
    let insurance_type_id = event.target.insurance_type_id.value;
    let count_period_id = 0; //event.target.count_period_id.value
    //
    let duration_period_id =
      car_sell_type_id === "1" ? 99 : event.target.duration_period_id.value;
    // car_sell_type_id===1 // 1.สด 2.ผ่อน
    // alert('duration_period_id='+duration_period_id);
    let bank_finance_id = event.target.bank_finance_id.value;
    let real_sell_price = event.target.real_sell_price.value;
    let normal_sell_price = event.target.normal_sell_price.value;
    let car_sell_discount = event.target.car_sell_discount.value;
    let rate_finance = event.target.rate_finance.value;
    let insurance_pa = event.target.insurance_pa.value;
    let tax_rate_finance = 0; //event.target.tax_rate_finance.value
    let total_rate_finance = 0; //event.target.total_rate_finance.value
    let sum_down = event.target.sum_down.value;

    // 9048 SC vat_down ไม่ต้องมี
    let vat_down = PORT === 9048 ? 0 : event.target.vat_down.value;

    let insurance_price = event.target.insurance_price.value;
    let cost_finance = event.target.cost_finance.value;
    let cost_transfer = 0; //event.target.cost_transfer.value
    let cost_period_month = 0; //event.target.cost_period_month.value
    let total_cost_period_call = 0; //event.target.total_cost_period_call.value
    let total_outof_car = event.target.total_outof_car.value;
    let balance_debt = event.target.balance_debt.value;
    let car_status_id = event.target.car_status_id.value;
    let date_promise = event.target.date_promise.value;
    let insurance_buy = event.target.insurance_buy.value;
    let promotion_name = event.target.promotion_name.value;
    //alert('insurance_buy='+insurance_buy)
    //ยอดขายเกิน
    let car_over_sales = event.target.car_over_sales.value;
    let car_excess_amount = event.target.car_excess_amount.value;
    let customer_cash = event.target.customer_cash.value;

    //pisan
    let monthly_installment = event.target.monthly_installment.value;
    let total_installment = event.target.total_installment.value;
    let first_installment = event.target.first_installment.value;
    let interest_installment = event.target.interest_installment.value;
    let car_issue_date = event.target.car_issue_date.value;
    let liciense_status_id = event.target.liciense_status_id.value;
    let car_transfer_date = event.target.car_transfer_date.value;
    let finance_payment_date = event.target.finance_payment_date.value;
    let agent_id = event.target.agent_id.value;
    //let sale_by_id = event.target.sale_by_id.value
    let sale_by_id = this.state.sale_by_id;
    // รายรับ
    // let vat_sell = event.target.vat_sell.value
    // let finance_commission = event.target.finance_commission.value
    // //thadyon-kmhome
    // let vat_commission = event.target.vat_commission.value
    // รายจ่าย
    let car_external_commission = event.target.car_external_commission.value;
    let sales_commission = event.target.sales_commission.value;
    let additional_commission = event.target.additional_commission.value;
    let advertising_cost = event.target.advertising_cost.value;
    let delivery_fee = event.target.delivery_fee.value;
    let promotion_fee = event.target.promotion_fee.value;
    //
    let finance_fee = event.target.finance_fee.value;
    let transfer_fee = event.target.transfer_fee.value;

    // sompong
    let pay_advance_finance = event.target.pay_advance_finance.value;
    // mario
    let sell_discount = event.target.sell_discount.value;
    // mktent
    let sell_finance_contract = event.target.sell_finance_contract.value;
    let sell_comment = this.state.sell_comment;
    // ber1
    let gearbox_warranty = event.target.gearbox_warranty.value;
    let gearbox_bank_name = event.target.gearbox_bank_name.value;
    let gearbox_amount = event.target.gearbox_amount.value;
    let debt_insurance_amount = event.target.debt_insurance_amount.value;
    // at
    let cost_after_sales_service = this.state.cost_after_sales_service;
    let finance_pa = this.state.finance_pa;
    let finance_car_insurance = this.state.finance_car_insurance;
    let finance_ew = this.state.finance_ew;
    let finance_pay_advance = this.state.finance_pay_advance;
    let finance_health_insurance = this.state.finance_health_insurance;
    let finance_document_fee = this.state.finance_document_fee;
    let finance_transfer_fee = this.state.finance_transfer_fee;
    let finance_stamp_fee = this.state.finance_stamp_fee;

    // at ขอเพิ่ม 12-8-66 ตาทำ
    let insurance_pa_buy = event.target.insurance_pa_buy.value;

    // รายรับ
    let tax_invoice_amount = this.state.tax_invoice_amount;
    let tax_invoice_vat = this.state.tax_invoice_vat;
    let vat_sell = this.state.vat_sell;
    let finance_commission = 0;
    let vat_commission = 0;

    let tax_commission_amount = this.state.tax_commission_amount;
    let tax_commission_vat = this.state.tax_commission_vat;

    // at
    let total_outof_discount = this.state.total_outof_discount;
    let transfer_fee_estimate = this.state.transfer_fee_estimate;

    let refund_type = this.state.refund_type;
    let refund_inpart = event.target.refund_inpart.value;
    //at ขอเพิ่มค่า พรบ.
    let cost_sell_act = event.target.cost_sell_act.value;

    if (Number(car_status_id) !== 23) {
      transfer_fee_estimate = 0;
    }

    let more_detail_id = 0;

    // familyCar
    if (port === 9046) {
      more_detail_id = event.target.more_detail_id.value;
    }

    // let yordJud =  rate_finance //this.state.rate_finance //xxx

    if (this.state.customer_id === "") {
      AlertWarning("กรุณาเลือกลูกค้า");
      this.refs.search_customer_name.focus();
      return;
    }

    if (sale_by_id === "") {
      AlertWarning("กรุณาเลือกผู้ขาย");
      return;
    }

    if (real_sell_price === "" || Number(real_sell_price) === 0) {
      AlertWarning("กรุณากรอกราคาขายจริง");
      return;
    }

    if (
      gearbox_warranty === "รับประกันเครื่องเกียร์" &&
      gearbox_bank_name === ""
    ) {
      AlertWarning("กรุณาระบุธนาคารที่รับประกันเครื่องเกียร์");
      return;
    }

    let index = event.nativeEvent.target.car_status_id.selectedIndex;
    let car_status_name = event.target.car_status_id[index].text;
    let car_name = this.state.car.car_name;
    let customer_name = this.state.customer.customer_name;
    let customer_mobile = this.state.customer.customer_mobile;
    let newMobile = NumberUtil.mobileFormat(customer_mobile);
    //let yordJud = real_sell_price - total_outof_car;
    let yordJud = rate_finance;
    let car_license_plate_new =
      this.state.car.car_license_plate_new === ""
        ? this.state.car.car_license_plate_old
        : this.state.car.car_license_plate_new;
    // let total_outof_car = this.state.total_outof_car
    let fullname = this.state.user.fullname;

    let employees = this.state.employees;
    let employee_filter = employees.filter(
      (em) => em.employee_id === Number(sale_by_id)
    );
    let employee_name = "-";
    if (employee_filter.length > 0) {
      employee_name = employee_filter[0].employee_name;
    }
    // let car_date_in = this.state.car.car_date_in
    // let diff = differenceInDays(new Date(), new Date(car_date_in));
    // let car_date_in_text = '\n📌 รวมวันที่อยู่ในสต๊อก : '+diff+' วัน (นับจากซื้อเข้า)'

    let line_real_sell_price = parseInt(real_sell_price, 10).toLocaleString();
    let line_total_outof_car = parseInt(total_outof_car, 10).toLocaleString();
    let line_yordJud = parseInt(yordJud, 10).toLocaleString();
    // NumberUtil.addCommas(yordJud)

    /*
    alert(message);
    return ;*/

    if (car_sell_type_id === "") {
      AlertWarning('กรุณาเลือก "ประเภทการขาย"');
      return;
    }

    if (car_sell_type_id === "2") {
      // 1.สด 2.ผ่อน
      if (bank_finance_id === "") {
        AlertWarning('กรุณาเลือก "ไฟแนนซ์"');
        return;
      }

      /*if (count_period_id === '') {
        AlertWarning('กรุณาเลือก "ระยะเวลาผ่อนชำระ"')
        return
      }*/

      if (duration_period_id === "") {
        AlertWarning('กรุณาเลือก "ระยะเวลาผ่อนชำระ"');
        return;
      }
    }
    // AT
    let cost_phra = this.state.cost_phra;
    let cost_vat_and_property_tax = this.state.cost_vat_and_property_tax;
    // 0 =  ไม่ระบุ / มี com , 1 = ไม่มี com
    let is_no_commission = this.state.is_no_commission;

    axios
      .post(APIURL + "/car_sell/", {
        car_id: car_id,
        customer_id: customer_id,
        car_sell_type_id: car_sell_type_id,
        insurance_company_id: insurance_company_id,
        insurance_type_id: insurance_type_id,
        count_period_id: count_period_id,
        duration_period_id: duration_period_id,
        bank_finance_id: bank_finance_id,
        real_sell_price: real_sell_price,
        normal_sell_price: normal_sell_price,
        car_sell_discount: car_sell_discount,
        rate_finance: rate_finance,
        insurance_pa: insurance_pa,
        tax_rate_finance: tax_rate_finance,
        total_rate_finance: total_rate_finance,
        sum_down: sum_down,
        vat_down: vat_down,
        insurance_price: insurance_price,
        cost_finance: cost_finance,
        cost_transfer: cost_transfer,
        cost_period_month: cost_period_month,
        total_cost_period_call: total_cost_period_call,
        total_outof_car: total_outof_car,
        balance_debt: balance_debt,
        car_status_id: car_status_id,
        date_promise: date_promise,
        insurance_buy: insurance_buy,
        promotion_name: promotion_name,
        user_created: this.state.user.user,
        user_updated: this.state.user.user,
        //
        car_over_sales: car_over_sales,
        car_excess_amount: car_excess_amount,
        customer_cash: customer_cash,
        //
        monthly_installment: monthly_installment,
        total_installment: total_installment,
        first_installment: first_installment,
        interest_installment: interest_installment,
        car_issue_date: car_issue_date,
        liciense_status_id: liciense_status_id,
        //
        car_transfer_date: car_transfer_date,
        finance_payment_date: finance_payment_date,
        agent_id: agent_id,
        sale_by_id: sale_by_id,
        // รายรับ
        vat_sell: vat_sell,
        finance_commission: finance_commission,
        vat_commission: vat_commission,
        tax_invoice_amount: tax_invoice_amount,
        tax_invoice_vat: tax_invoice_vat,
        // รายจ่าย
        car_external_commission: car_external_commission,
        sales_commission: sales_commission,
        additional_commission: additional_commission,
        advertising_cost: advertising_cost,
        delivery_fee: delivery_fee,
        promotion_fee: promotion_fee,
        finance_fee: finance_fee,
        transfer_fee: transfer_fee,
        pay_advance_finance: pay_advance_finance,
        sell_discount: sell_discount,
        sell_finance_contract: sell_finance_contract,
        sell_comment: sell_comment,
        gearbox_warranty: gearbox_warranty,
        gearbox_bank_name: gearbox_bank_name,
        gearbox_amount: gearbox_amount,
        debt_insurance_amount: debt_insurance_amount,
        cost_phra,
        cost_vat_and_property_tax,
        more_detail_id: more_detail_id,
        cost_after_sales_service: cost_after_sales_service,
        finance_pa: finance_pa,
        finance_car_insurance: finance_car_insurance,
        finance_ew: finance_ew,
        finance_pay_advance: finance_pay_advance,
        finance_health_insurance: finance_health_insurance,
        finance_document_fee: finance_document_fee,
        finance_transfer_fee: finance_transfer_fee,
        finance_stamp_fee: finance_stamp_fee,
        tax_commission_amount: tax_commission_amount,
        tax_commission_vat: tax_commission_vat,
        total_outof_discount: total_outof_discount,
        transfer_fee_estimate: transfer_fee_estimate,
        refund_type: refund_type,
        refund_inpart: refund_inpart,
        insurance_pa_buy: insurance_pa_buy,
        is_no_commission: is_no_commission,
        cost_sell_act: cost_sell_act,
      })
      .then((response) => {
        // '\nดาวน์ : ' + NumberUtil.addCommas(total_outof_car) +
        if (response.status === 200) {
          let data = response.data;
          let result = data.result;

          if (result === "success") {
            // TODO: 365car จำนวนรถตามคนขาย / ทั้งหมดของเดือน
            // เดือน xxxx 2566
            // วันที่ ปป
            // let employees = this.state.employees
            //           // let employee_filter = employees.filter(em => em.employee_id === Number(sale_by_id))
            //           // let employee_name = '-'
            //           // if(employee_filter.length > 0) {
            //           //   employee_name = employee_filter[0].employee_name
            //           // }
            let sell_employee = response.data.sell_employee;

            let sell_date = response.data.sell_date;
            let sell_all = response.data.sell_all;

            //
            let month_int = format(new Date(sell_date), "MM-yyyy");
            let sell_month_thai = MonthUtil.convertMonthYear(month_int);
            let sell_date_thai = DateUtil.convertShortDateThaiDash(sell_date);
            let car_date_in = this.state.car.car_date_in;
            let car_sale_price = this.state.car.car_sale_price;

            let sell_title =
              "\nขาย" +
              sell_month_thai +
              " \nวันที่ขาย : " +
              sell_date_thai +
              " "; // 1
            let sell_employee_case =
              "\nเคส" + employee_name + "ปล่อย : คันที่ " + sell_employee; // 2
            let sell_all_text = "\nรวมปล่อยรถ : คันที่ " + sell_all; // 3

            let diff = differenceInDays(new Date(), new Date(car_date_in));
            let car_date_in_text =
              "\n📌 รวมวันที่อยู่ในสต๊อก : " + diff + " วัน ";
            let profile_from = this.state.profile_from;
            // bank_finance_id
            let bank_name = this.state.bank.filter(
              (b) => b.bank_id === Number(bank_finance_id)
            )[0].bank_name;
            let line_car_sale_price = parseInt(
              car_sale_price,
              10
            ).toLocaleString();

            let message = "";
            // if(PORT >= 9056) {
            if (PORT === 9062) {
              // champauto
              // '\n📌 ราคาขายปิดจบ : ' + line_real_sell_price +
              let total_outof_discount_comma =
                NumberUtil.addCommasZeroInt(total_outof_discount);
              message =
                "สถานะ: " +
                car_status_name +
                sell_title +
                sell_employee_case +
                sell_all_text +
                car_date_in_text +
                "\n📌 รูปแบบการซื้อ: " +
                bank_name +
                "\n📌 แหล่งที่มา: " +
                profile_from +
                "\n📌 รุ่น: " +
                car_name +
                "\n📌 ทะเบียน : " +
                car_license_plate_new +
                " " +
                "\n📌 ราคาตั้งขาย : " +
                line_car_sale_price +
                "\n📌 ส่วนลดเงินออกรถ : " +
                total_outof_discount_comma +
                "\n📌 รวมออกรถ : " +
                line_total_outof_car +
                "\n📌 ยอดจัด : " +
                line_yordJud +
                "\n📌 ลูกค้า : " +
                customer_name +
                "\n📌 โทร: " +
                newMobile +
                "\n📌 ขายโดย: " +
                employee_name +
                "\n📌 ผู้ทำรายการ: " +
                fullname;
            } else {
              message =
                "สถานะ: " +
                car_status_name +
                sell_title +
                sell_employee_case +
                sell_all_text +
                car_date_in_text +
                "\n📌 รูปแบบการซื้อ: " +
                bank_name +
                "\n📌 แหล่งที่มา: " +
                profile_from +
                "\n📌 รุ่น: " +
                car_name +
                "\n📌 ทะเบียน : " +
                car_license_plate_new +
                " " +
                "\n📌 ราคาตั้งขาย : " +
                line_car_sale_price +
                "\n📌 ราคาขายปิดจบ : " +
                line_real_sell_price +
                "\n📌 รวมออกรถ : " +
                line_total_outof_car +
                "\n📌 ยอดจัด : " +
                line_yordJud +
                "\n📌 ลูกค้า : " +
                customer_name +
                "\n📌 โทร: " +
                newMobile +
                "\n📌 ขายโดย: " +
                employee_name +
                "\n📌 ผู้ทำรายการ: " +
                fullname;
            }
            /*} else {
              message = 'สถานะ: ' + car_status_name +
                  sell_title +
                  sell_employee_case +
                  sell_all_text +
                  car_date_in_text+
                  '\n📌 รุ่น: ' + car_name +
                  '\n📌 ทะเบียน : ' + car_license_plate_new + ' ' +
                  '\n📌 ลูกค้า : ' + customer_name +
                  '\n📌 โทร: ' + newMobile +
                  '\n📌 ราคาตั้งขาย : ' + line_car_sale_price +
                  '\n📌 ราคาขายจริง : ' + line_real_sell_price +
                  '\n📌 รวมออกรถ : ' + line_total_outof_car +
                  '\n📌 ยอดจัด : ' + line_yordJud +
                  '\n📌 ขายโดย: ' + employee_name +
                  '\n📌 ผู้ทำรายการ: ' + fullname
            }*/

            LineNotify.sendNotify(message, "sell");
            this.props.history.push("/sales/list");
          } else if (result === "repeat") {
            this.props.history.push("/sales/list");
          }
        }
      })
      .catch((error) => {
        AlertError("ผิดพลาด: " + error);
        console.log("error:", error);
        // alert('พอข้อผิดพลาด: ' + error)
      });
  }

  /*formatDate (date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
  }*/

  handleOnChangeCarPrice() {
    let real_sell_price = Number(this.state.real_sell_price); // ราคาขายจริง
    let normal_sell_price = Number(this.state.normal_sell_price); // ราคาปกติ
    let rate_finance = Number(this.state.rate_finance); // ยอดจัดไฟแนนซ์

    if (real_sell_price === "") {
      real_sell_price = 0;
    }

    if (rate_finance === "") {
      rate_finance = 0;
    }

    let discount = 0;

    if (normal_sell_price !== "" && normal_sell_price > 0) {
      discount = Number(normal_sell_price) - Number(real_sell_price);
    }

    let real_discount = discount >= 0 ? discount : 0;
    let car_over_sales = 0;

    if (real_sell_price > normal_sell_price) {
      car_over_sales = real_sell_price - normal_sell_price;
    }

    this.setState({
      car_sell_discount: real_discount, // ราคาส่วนลด
      car_over_sales: car_over_sales,
    });

    let profite_sum_down = 0;

    if (real_sell_price !== "" && real_sell_price > 0) {
      profite_sum_down = Number(real_sell_price) - Number(rate_finance);
    }

    let car_excess_amount = 0; // ยอดจัดเกิน
    if (rate_finance > real_sell_price) {
      profite_sum_down = 0;
      car_excess_amount = rate_finance - real_sell_price;
    }

    if (rate_finance === 0) {
      profite_sum_down = 0;
    }

    // else {
    //   profite_sum_down = profite_sum_down + vat_sell
    // }

    if (this.state.car_sell_type_id === "1") {
      // ซื้อเงินสด
      this.setState(
        {
          sum_down: 0, // เงินดาวน์
          car_excess_amount: 0,
          vat_down: 0,
        },
        () => {
          this.handleOnChangeCarPricePA();
          this.handleOnChangeCarPriceOutof();
        }
      );
    } else {
      let sell_discount = Number(this.state.sell_discount);

      if (sell_discount > 0) {
        profite_sum_down = profite_sum_down - sell_discount;
        // car_excess_amount = car_excess_amount - sell_discount
      }

      if (profite_sum_down + sell_discount === car_excess_amount) {
        car_excess_amount = 0;
      }

      let is_key_vat_down = this.state.is_key_vat_down;

      let vat_down = 0;
      if (is_key_vat_down) {
        vat_down = Number(this.state.vat_down);
      } else {
        const vat = Number(this.state.vat) / 100;
        let vat_down_cal = profite_sum_down * vat;
        vat_down = parseFloat(String(vat_down_cal)).toFixed(2);
      }

      vat_down = PORT === 9048 ? 0 : vat_down;

      this.setState(
        {
          sum_down: profite_sum_down,
          car_excess_amount: car_excess_amount,
          vat_down: vat_down,
        },
        () => {
          this.handleOnChangeCarPricePA();
          this.handleOnChangeCarPriceOutof();
        }
      );
    }
  }

  handleOnChangeCarPricePA() {
    let rate_finance = this.state.rate_finance; // ยอดจัดไฟแนนซ์
    let insurance_pa = this.state.insurance_pa;
    let tax_rate_finance = this.state.tax_rate_finance;

    if (rate_finance === "") rate_finance = 0;

    if (insurance_pa === "") insurance_pa = 0;

    if (tax_rate_finance === "") tax_rate_finance = 0;

    var profite_total_finance = 0;

    if (rate_finance !== "" && rate_finance > 0)
      profite_total_finance =
        Number(rate_finance) + Number(insurance_pa) + Number(tax_rate_finance);

    this.setState({
      total_rate_finance: profite_total_finance, // ราคาส่วนลด
    });
  }

  handleOnChangeCarPriceOutof() {
    let sum_down = this.state.sum_down; // ยอดดาวน์
    let insurance_price =
      this.state.insurance_buy === "ประกันแถม" ? 0 : this.state.insurance_price; //ราคาประกัน
    let cost_finance = this.state.cost_finance; //ค่าจัดไฟแนนซ์
    let cost_transfer = 0; // this.state.cost_transfer //ค่าโอน
    let car_pay_all = this.state.car_pay_all; // เงินที่จ่ายไปแล้ว เงินจอง เงินมัดจำ
    let real_sell_price = this.state.real_sell_price;
    let pay_advance_finance = this.state.pay_advance_finance; // เก็บค่างวดรถล่วงหน้า
    let insurance_pa =
      this.state.insurance_pa_buy === "PA แถม" ? 0 : this.state.insurance_pa; //ราคาประกันชีวิต PA

    let gearbox_amount = Number(this.state.gearbox_amount); // ยอดประกันเครื่องเกียร์
    let debt_insurance_amount = Number(this.state.debt_insurance_amount); // ประกันภาระหนี้

    let cost_sell_act = Number(this.state.cost_sell_act); //ค่า พรบ.

    if (port === "9005" || port === 9005) {
      // pisan ไม่รวม pa ในรวมออกรถ
      insurance_pa = 0;
    }
    // let car_external_commission = Number(this.state.car_external_commission) // ค่านายหน้า ภายนอก
    // let vat_sell = Number(this.state.vat_sell) // vat ขาย

    if (sum_down === "") sum_down = 0;

    if (insurance_price === "") insurance_price = 0;

    if (cost_finance === "") {
      cost_finance = 0;
    }

    if (insurance_pa === "") insurance_pa = 0;

    cost_finance = cost_finance - Number(car_pay_all);

    if (cost_transfer === "") cost_transfer = 0;

    if (cost_sell_act === "") {
      cost_sell_act = 0;
    }

    let profite_total_outof_car = 0;

    if (sum_down !== "" && sum_down > 0) {
      profite_total_outof_car =
        Number(sum_down) +
        Number(insurance_price) +
        Number(cost_finance) +
        Number(cost_transfer) +
        Number(pay_advance_finance) +
        Number(insurance_pa) +
        gearbox_amount +
        debt_insurance_amount +
        cost_sell_act;
    } else if (sum_down === 0) {
      profite_total_outof_car =
        Number(insurance_price) +
        Number(cost_finance) +
        Number(cost_transfer) +
        Number(pay_advance_finance) +
        Number(insurance_pa) +
        gearbox_amount +
        debt_insurance_amount +
        cost_sell_act;
    }

    if (this.state.car_sell_type_id === "1") {
      profite_total_outof_car =
        Number(real_sell_price) +
        Number(insurance_price) +
        Number(cost_finance) +
        Number(cost_transfer) +
        Number(pay_advance_finance) +
        Number(insurance_pa) +
        gearbox_amount +
        debt_insurance_amount +
        cost_sell_act;
    }

    let car_excess_amount = Number(this.state.car_excess_amount); //ยอดจัดเกิน
    let customer_cash = 0; // คิดเงินคืนลูกค้า

    let vat_down = this.state.is_vat === 0 ? 0 : Number(this.state.vat_down);
    profite_total_outof_car = profite_total_outof_car + vat_down;

    if (car_excess_amount >= profite_total_outof_car) {
      customer_cash = car_excess_amount - profite_total_outof_car;
      profite_total_outof_car = 0;
    } else {
      // ราคา ออกรถมากกว่า
      customer_cash = 0;
      profite_total_outof_car =
        Number(profite_total_outof_car) - Number(car_excess_amount);
    }

    let sum_pay = Number(this.state.sum_pay);
    let balance_debt = Number(profite_total_outof_car) - sum_pay;
    let total_outof_discount = Number(this.state.total_outof_discount);

    if (total_outof_discount > 0) {
      profite_total_outof_car = profite_total_outof_car - total_outof_discount;
      balance_debt = balance_debt - total_outof_discount;
    }

    // if (PORT === 9064) {
    //   // 69car
    //   let paid_already = Number(this.state.paid_already)
    //   if(car_excess_amount >= profite_total_outof_car) {
    //     customer_cash = paid_already - Number(real_sell_price)
    //   }
    //
    // // กรณีจ่ายยังไม่ครบ
    //   if (real_sell_price > paid_already) {
    //     customer_cash = 0
    //     balance_debt = real_sell_price - paid_already
    //   }
    //
    // }
    if (PORT === 9064) {
      if (car_excess_amount > 0) {
        let sum_car_books = this.state.sum_car_books;
        customer_cash = customer_cash + Number(sum_car_books);
      }
    }

    // fix กรณีเงินเกิน ยังเหลือ
    // let vat_down = this.state.is_vat === 0 ? 0 : Number(this.state.vat_down)
    // profite_total_outof_car = profite_total_outof_car + vat_down

    // var balance_debt = Number(profite_total_outof_car) - Number(car_pay_all)

    this.setState({
      total_outof_car: profite_total_outof_car, // รวมออกรถ/บาท
      customer_cash: customer_cash,
      balance_debt: balance_debt,
    });

    // this.setState({
    //   balance_debt: Number(profite_total_outof_car) - Number(car_pay_all) // ยอดคงเหลือค้างชำระ/บาท
    // })
  }

  /* handleOnChangeCarPriceOutof () {

    var sum_down = this.state.sum_down // ยอดดาวน์
    var insurance_price = (this.state.insurance_buy ==='ประกันแถม') ? 0 : this.state.insurance_price //ราคาประกัน
    var cost_finance = this.state.cost_finance //ค่าจัดไฟแนนซ์
    var cost_transfer = 0 //this.state.cost_transfer //ค่าโอน

    var car_pay_all = this.state.car_pay_all // เงินที่จ่ายไปแล้ว เงินจอง เงินมัดจำ
    var real_sell_price = this.state.real_sell_price
    var car_external_commission = 0 //Number(this.state.car_external_commission) //ค่านายหน้า ภายนอก

    if (sum_down === '')
      sum_down = 0

    if (insurance_price === '')
      insurance_price = 0

    if (cost_finance === '')
      cost_finance = 0

    if (cost_transfer === '')
      cost_transfer = 0

    var profite_total_outof_car = 0

    if (sum_down !== '' && sum_down > 0) {
      profite_total_outof_car = Number(sum_down) + Number(insurance_price) + Number(cost_finance) + Number(cost_transfer) + car_external_commission
    }else if(sum_down===0){
      profite_total_outof_car = Number(insurance_price) + Number(cost_finance) + Number(cost_transfer) + car_external_commission
    }

    if (this.state.car_sell_type_id === '1') {
      profite_total_outof_car = Number(real_sell_price) + Number(insurance_price) + Number(cost_finance) + Number(cost_transfer) + car_external_commission
    }

    var car_excess_amount = Number(this.state.car_excess_amount) //ยอดจัดเกิน
    var customer_cash = 0 // คิดเงินคืนลูกค้า

    if(car_excess_amount >= profite_total_outof_car) {
      customer_cash = car_excess_amount - profite_total_outof_car
      profite_total_outof_car = 0
    }else{
      //ราคา ออกรถมากกว่า
      customer_cash = 0
      profite_total_outof_car = Number(profite_total_outof_car) - Number(car_excess_amount)
    }

    var balance_debt = Number(profite_total_outof_car) - Number(car_pay_all)

    this.setState({
      total_outof_car: profite_total_outof_car, // รวมออกรถ/บาท
      customer_cash: customer_cash,
      balance_debt: balance_debt
    })

   // this.setState({
   //   balance_debt: Number(profite_total_outof_car) - Number(car_pay_all) // ยอดคงเหลือค้างชำระ/บาท
   // })

  } */

  /* handleOnChangeCarPriceCostPeriod () {

    var cost_period_month = 0 //this.state.cost_period_month // ค่างวดล่วงหน้า/เดือน
    var count_period_id =  0 //this.state.count_period_id //จำนวนงวด
    //var count_period_name = event.target.count_period_name.value
    //alert(count_period_id)

    if (cost_period_month === '')
      cost_period_month = 0

    if (count_period_id === '')
      count_period_id = 0

    var profite_total_cost_period_call

    if (cost_period_month !== '' && count_period_id > 0)
      profite_total_cost_period_call = Number(cost_period_month) * Number(count_period_id)
    else
      profite_total_cost_period_call = 0

    /!* this.setState({
      total_cost_period_call: profite_total_cost_period_call // ราคาส่วนลด
    })*!/

  }*/

  /*addCarSellPay () {
    //event.preventDefault()
    let car_id = this.state.car_id //
    let customer_id = this.state.customer_id
    // let date_pay = this.formatDate(this.state.startDatePaySell)
    let date_pay = moment(this.state.startDatePaySell).format('YYYY-MM-DD')
    let car_sell_list_pay_id = this.refs.car_sell_list_pay_id.value
    let car_sell_pay_count = this.refs.car_sell_pay_count.value
    let sales_type_id = this.refs.sales_type_id.value
    let bank_id = this.refs.bank_id.value
    let person_transaction = this.state.user.user

    if (customer_id === '') {
      AlertWarning('กรุณาเลือกค้นหาลูกค้า')
      return
    }

    if (car_sell_list_pay_id === '') {
      AlertWarning('กรุณาเลือกรายการชำระ')
      return
    }

    if (car_sell_pay_count === '0') {
      AlertWarning('กรุณากรอกยอดเงินที่ชำระ')
      return
    }

    if (sales_type_id === '') {
      AlertWarning('กรุณาเลือกประเภทการรับชำระ')
      return
    }

    if (bank_id === '') {
      AlertWarning('กรุณาเลือกธนาคาร')
      return
    }

    let check_doc_no = this.state.check_doc_no
    if(check_doc_no === 'repeat'){
      AlertError('เลขที่เอกสารซ้ำ กรุณาแก้ไข')
      return
    }

    let company_setting = this.state.company_setting
    let doc_type = this.state.doc_type
    let doc_config = this.state.doc_config
    let is_vat = this.state.is_vat
    let include_vat = this.state.include_vat
    let vat = is_vat === 1 ? company_setting.vat : 0
    let vat_bath = 0
    if (is_vat === 1 && include_vat === 1 && vat !== 0) {
      // car_sell_pay_count ยอดรวม vat แล้ว
      vat_bath = getVatBathIncludeVat(car_sell_pay_count, vat)
    } else if (is_vat === 1 && include_vat === 0 && vat !== 0) {
      // car_sell_pay_count ยอดยังไม่รวม vat
      vat_bath = getVatBathFromAmount(car_sell_pay_count, vat)
    }

    let doc_no = ''
    if (doc_config === 'manual') {
      doc_no = this.state.doc_no
    }

    let data = {
      car_id: car_id,
      customer_id: customer_id,
      date_pay: date_pay,
      car_sell_list_pay_id: car_sell_list_pay_id,
      car_sell_pay_count: car_sell_pay_count,
      sales_type_id: sales_type_id,
      bank_id: bank_id,
      person_transaction: person_transaction,
      user_created: this.state.user.user,
      user_updated: this.state.user.user,
      doc_type: doc_type,
      doc_config: doc_config,
      vat: vat,
      vat_bath: vat_bath,
      include_vat: include_vat,
      doc_no: doc_no
    }

    // TODx: เพิ่มการชำระเงิน car_sell_pay
    axios.post(APIURL + '/car_sell_pay/', data)
      .then(res => {
        //that.props.history.push('/sales/list')
        if(res.status === 200){
          this.clearFormCarSellPay()
          this.loadDataCarSellPay()
        }
      })
      .catch(error => {
        console.log('error:', error)
        // alert('พบข้อผิดพลาด: ' + error)
      })
  }*/

  handleCarSellPayAddSubmit(event) {
    event.preventDefault();
    let car_id = this.state.car_id; //
    let customer_id = this.state.customer_id;
    // let date_pay = this.formatDate(this.state.startDatePaySell)
    // let date_pay = moment(this.state.startDatePaySell).format('YYYY-MM-DD')
    let date_pay = event.target.date_pay.value;
    let car_sell_list_pay_id = this.refs.car_sell_list_pay_id.value;
    let car_sell_pay_count = this.refs.car_sell_pay_count.value;
    let sales_type_id = this.refs.sales_type_id.value;
    let bank_id = this.refs.bank_id.value;
    let person_transaction = this.state.user.user;

    if (customer_id === "") {
      AlertWarning("กรุณาเลือกค้นหาลูกค้า");
      return;
    }

    if (car_sell_list_pay_id === "") {
      AlertWarning("กรุณาเลือกรายการชำระ");
      return;
    }

    if (car_sell_pay_count === "0") {
      AlertWarning("กรุณากรอกยอดเงินที่ชำระ");
      return;
    }

    if (sales_type_id === "") {
      AlertWarning("กรุณาเลือกประเภทการรับชำระ");
      return;
    }

    if (bank_id === "") {
      AlertWarning("กรุณาเลือกธนาคาร");
      return;
    }

    let company_setting = this.state.company_setting;
    let doc_type = this.state.doc_type;
    let doc_config = this.state.doc_config;
    let is_vat = this.state.is_vat;
    let include_vat = this.state.include_vat;
    let vat = is_vat === 1 ? company_setting.vat : 0;
    let vat_bath = 0;

    // ค่างวดล่วงหน้า 7 === car_sell_list_pay_id
    if (car_sell_list_pay_id === 7) {
      doc_type = "RE";
      is_vat = 0;
      include_vat = 0;
      vat = 0;
    }

    let receipt_type = event.target.receipt_type.value;
    if (receipt_type === "ออกใบเสร็จรับเงิน") {
      doc_type = "RE";
      is_vat = 0;
      include_vat = 0;
      vat = 0;
    } else if (receipt_type === "ออกใบกำกับภาษี") {
      if (is_vat === 1 && include_vat === 1 && vat !== 0) {
        // car_sell_pay_count ยอดรวม vat แล้ว
        vat_bath = getVatBathIncludeVat(car_sell_pay_count, vat);
      } else if (is_vat === 1 && include_vat === 0 && vat !== 0) {
        // car_sell_pay_count ยอดยังไม่รวม vat
        vat_bath = getVatBathFromAmount(car_sell_pay_count, vat);
      }
    }

    doc_config = getDocTypeConfig(company_setting, doc_type);

    let doc_no = "";
    if (doc_config === "manual") {
      doc_no = this.state.doc_no;
    }

    let check_doc_no = this.state.check_doc_no;
    if (check_doc_no === "repeat") {
      AlertError("เลขที่เอกสารซ้ำ กรุณาแก้ไข");
      return;
    }

    if (doc_config === "manual" && doc_no === "") {
      AlertError("กรุณากรอกเลขเอกสาร");
      return;
    }

    /*console.log('receipt_type=', receipt_type)
    console.log('doc_type=', doc_type)
    console.log('is_vat=', is_vat)
    console.log('include_vat=', include_vat)
    console.log('vat=', vat)
    console.log('vat_bath=', vat_bath)
    return;*/

    let data = {
      car_id: car_id,
      customer_id: customer_id,
      date_pay: date_pay,
      car_sell_list_pay_id: car_sell_list_pay_id,
      car_sell_pay_count: car_sell_pay_count,
      sales_type_id: sales_type_id,
      bank_id: bank_id,
      person_transaction: person_transaction,
      user_created: this.state.user.user,
      user_updated: this.state.user.user,
      //
      doc_type: doc_type,
      doc_config: doc_config,
      vat: vat,
      vat_bath: vat_bath,
      include_vat: include_vat,
      doc_no: doc_no,
    };

    /*console.log('===data===')
    console.log(data)
    return;*/

    // TODx: เพิ่มการชำระเงิน car_sell_pay
    axios
      .post(APIURL + "/car_sell_pay/", data)
      .then((res) => {
        //that.props.history.push('/sales/list')
        if (res.status === 200) {
          this.setState(
            {
              toggle_pay_add: !this.state.toggle_pay_add,
              doc_no: "",
            },
            () => {
              this.clearFormCarSellPay();
              this.loadDataCarSellPay();
            }
          );
        }
      })
      .catch((error) => {
        console.log("error:", error);
        // alert('พบข้อผิดพลาด: ' + error)
      });
  }

  loadData() {
    axios
      .get(APIURL + "/car_sell/")
      .then((res) => {
        //alert("res"+res);
        if (res.status === 200) this.setState({ lists: res.data });
      })
      .catch((error) => {
        console.log("error:", error);
        this.setState({ lists: [] });
      });
  }

  loadCarById() {
    // var that = this
    axios
      .get(APIURL + "/car/" + this.state.car_id)
      .then((res) => {
        let car = res.data[0];
        this.setState({
          car: car,
          normal_sell_price: car.car_sale_price,
          real_sell_price: car.car_sale_price,
        });
      })
      .catch((error) => {
        alert("พบข้อผิดพลาด: " + error);
        this.setState({ car: {} });
      });
  }

  async checkTaxInvoiceNumberRepeat() {
    let doc_no = this.state.doc_no;

    if (doc_no === "") {
      return;
    }

    let data = await checkDocNo(doc_no);

    this.setState({
      check_doc_no: data,
    });
  }

  componentWillMount() {
    //const queryString = require('query-string');
    this.setState({
      user: JSON.parse(this.props.user),
    });
  }

  async componentDidMount() {
    this.mounted = true;
    const queryString = require("query-string");
    let car = queryString.parse(this.props.location.search);
    // this.setState({car_id : car.car_id});
    await this.loadCompanySetting();

    this.setState({ car_id: car.car_id }, () => {
      this.loadCarById();
    });

    this.loadGroupPermission();
    this.loadFormControls();
    this.loadBankData();
    this.loadCarSellTypeData();
    this.loadInsuranceCompanyData();
    this.loadInsuranceTypeData();
    this.loadCountPeriodData();
    this.loadDurationPeriodData();
    this.loadCarSellListPayData();
    this.loadCarStatusData();
    this.loadSalesTypeData();
    this.loadEmployeeData();
    this.loadBankDataIsBank();
    this.loadMoreDetailData();
    this.loadPromotionData();
    this.loadLicienseStatus();

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  loadGroupPermission() {
    let type = this.props.type;
    let menuID = this.state.menuID;

    getGroupPermission(type, menuID).then((res) => {
      if (res.data.result === "success") {
        this.setState({
          grouppermissions: res.data.grouppermissions,
        });
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  loadFormControls() {
    let tableName = "car_sell";
    axios
      .get(APIURL + "/form_controls/" + tableName)
      .then((res) => {
        this.setState({ form_controls: res.data });
      })
      .catch((error) => {
        this.setState({ form_controls: [] });
      });
  }

  searchCustomer() {
    let search_text = this.refs.search_customer_name.value;
    this.getDataCustomerSearch(search_text);
  }

  getDataCustomerSearch(search_text) {
    axios
      .get(APIURL + "/customer/search/" + search_text)
      .then((res) => {
        if (res.status === 200) {
          this.setState({ customer_list: res.data });
        }
      })
      .catch((error) => {
        this.setState({ customer_list: [] });
      });
  }

  onCustomerSelect(customer, event) {
    this.setState(
      {
        customer_select: true,
        customer: customer,
        customer_id: customer.customer_id,
      },
      () => {
        this.loadProfile(customer.customer_id);
        this.loadDataCarSellPay();
      }
    );
  }

  loadProfile(customer_id) {
    axios.get(APIURL + "/profile/customer/" + customer_id).then((res) => {
      if (res.data.length > 0) {
        let profile = res.data[0];
        this.setState({
          profile_from: profile.profile_from,
        });
      }
    });
  }

  carSalesPayTypeChange(obj) {
    let value = obj.target.value;

    this.setState({ sales_type_id: value }, () => {
      if (value === "1") {
        this.refs.bank_id.value = "1";
      } else {
        this.refs.bank_id.value = "";
      }
    });
  }

  clearFormCarSellPay() {
    this.refs.car_sell_list_pay_id.value = "";
    this.refs.sales_type_id.value = "";
    this.setState({
      doc_no: "",
      date_pay: new Date(),
      car_sell_pay_count: "",
    });
  }

  loadDataCarSellPay() {
    if (this.state.car_id === "" || this.state.customer_id === "") {
      return;
    }
    axios
      .get(
        APIURL +
          "/car_sell_pay/buy/" +
          this.state.car_id +
          "/" +
          this.state.customer_id
      )
      .then((res) => {
        this.setState({ car_sell_pay_list: res.data }, () => {
          let car_sell_pay_list = res.data;
          let sum_pay = 0;
          let sum_car_books = 0;
          if (car_sell_pay_list.length > 0) {
            sum_pay = car_sell_pay_list.reduce(
              (acc, pay) => acc + pay.car_sell_pay_count,
              0
            );
            let pay_books = car_sell_pay_list.filter(
              (pay) => pay.car_sell_list_pay_name === "เงินจอง"
            );
            if (pay_books.length > 0) {
              sum_car_books = pay_books.reduce(
                (acc, pay) => acc + pay.car_sell_pay_count,
                0
              );
            }
          }

          this.setState(
            {
              sum_pay: sum_pay,
              sum_car_books: sum_car_books,
            },
            () => {}
          );
        });
      })
      .catch((error) => {
        //alert("error"+error.message);
        this.setState({ car_sell_pay_list: [] });
      });
  }

  carSalesTypeChange(obj) {
    //alert (obj.target.value)
    if (obj.target.value === "1") {
      // เงินสด
      this.refs.bank_finance_id.value = "1";
      this.setState({
        car_sell_type_id: obj.target.value,
        rate_finance: 0,
        sum_down: 0,
        vat_down: 0,
      });
      //this.refs.bank_finance_id.disable = true
    } else {
      this.setState({ car_sell_type_id: obj.target.value });
      this.refs.bank_finance_id.value = "";
    }
  }

  loadEmployeeData() {
    axios
      .get(APIURL + "/employee/")
      .then((res) => {
        if (res.status === 200) {
          let data = res.data;
          if (data.length > 0) {
            let dataFilter = data.filter(
              (d) => d.employee_position.indexOf("ขาย") !== -1
            );
            this.setState({ employees: dataFilter });
          } else {
            this.setState({ employees: [] });
          }
        }
      })
      .catch((error) => {
        console.log("error:", error);
        this.setState({ employees: [] });
      });
  }

  printOcpb(car_sell_pay) {
    const { company_setting } = this.state;

    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;
    let juristic_number = company_setting.juristic_number;
    let company_tel =
      company_setting.company_tel === "" ? "-" : company_setting.company_tel;

    // let is_vat = company_setting.is_vat
    // let company_vat = company_setting.vat

    // ตามสาขา
    // let car_brance = this.state.car.branch_name
    // let car_brance_address = this.state.car.branch_address
    // let car_brance_tel = this.state.car.branch_tel

    let car_brance = company_name;
    let car_brance_address = company_address;
    let car_brance_tel = company_tel;

    // include_vat , vat , vat_bath , doc_type , doc_no
    let vat = car_sell_pay.vat;
    let bill_title =
      vat !== 0 ? "ใบเสร็จรับเงิน / ใบกำกับภาษี" : "ใบเสร็จรับเงิน";

    let car_sell_pay_id = car_sell_pay.car_sell_pay_id;
    let include_vat = car_sell_pay.include_vat;
    // let vat = car_sell_pay.vat
    let vat_bath = car_sell_pay.vat_bath;
    let doc_type = car_sell_pay.doc_type;
    let doc_no =
      car_sell_pay.doc_no === null
        ? "R" + String(car_sell_pay_id)
        : car_sell_pay.doc_no;

    bill_title =
      doc_type === null
        ? bill_title
        : doc_type === "RT"
        ? "ใบเสร็จรับเงิน / ใบกำกับภาษี"
        : "ใบเสร็จรับเงิน";

    let car_name = this.state.car.car_name; //ยี่ห้อรถ
    let car_color_name = this.state.car.car_color_name; //สี
    let car_year_name = this.state.car.car_year_name; //ปี
    //let car_license_plate_new = this.state.car.car_license_plate_new //ทะเบียนรถยนต์
    //let car_province_name_new = this.state.car.province_name_new//จังหวัด
    let car_license_plate =
      this.state.car.car_license_plate_new !== "" &&
      this.state.car.car_license_plate_new !==
        this.state.car.car_license_plate_old
        ? this.state.car.car_license_plate_new
        : this.state.car.car_license_plate_old;

    let province_name =
      this.state.car.car_license_plate_new !== "" &&
      this.state.car.car_license_plate_new !==
        this.state.car.car_license_plate_old
        ? this.state.car.province_name_new
        : this.state.car.province_name_old;

    let customer_name = this.state.customer.customer_name; //ชื่อลูกค้า
    let customer_lastname = this.state.customer.customer_lastname; //นามสกุลลูกค้า
    let customer_address = this.state.customer.customer_address; //ที่อยู่ลูกค้า
    let customer_mobile = this.state.customer.customer_mobile; //
    let date_pay = moment(car_sell_pay.date_pay).locale("th").format("LL"); //วันที่ออกใบเสร็จหรือวันที่จ่าย
    let person_transaction = car_sell_pay.person_transaction; //ผู้ออกใบเสร็จ
    let car_sell_list_pay = car_sell_pay.car_sell_list_pay_name; //รายการที่จ่าย
    let sales_type = car_sell_pay.sales_type_name; //รูปแบบการจ่าย

    let car_sell_pay_no_vat = 0;
    let car_sell_pay_with_vat = 0;

    if (vat !== 0 && include_vat === 1) {
      // ราคา car_sell_pay_count รวม vat มาแล้ว
      car_sell_pay_no_vat =
        Number(car_sell_pay.car_sell_pay_count) - Number(vat_bath);
      car_sell_pay_with_vat = car_sell_pay.car_sell_pay_count;
    } else if (vat !== 0 && include_vat === 0) {
      // ราคา car_sell_pay_count ยังไม่รวม vat มาแล้ว
      car_sell_pay_no_vat = car_sell_pay.car_sell_pay_count;
      car_sell_pay_with_vat =
        Number(car_sell_pay.car_sell_pay_count) + Number(vat_bath);
    } else {
      car_sell_pay_no_vat = car_sell_pay.car_sell_pay_count;
      car_sell_pay_with_vat = car_sell_pay.car_sell_pay_count;
    }

    // let car_sell_pay_count = '฿' + car_sell_pay.car_sell_pay_count.toLocaleString()  //ยอดเงิน
    // let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)

    let car_sell_pay_no_vat_fix = parseFloat(car_sell_pay_no_vat).toFixed(2);

    let car_sell_pay_no_vat_str =
      "฿" + NumberUtil.addCommas(String(car_sell_pay_no_vat_fix));
    let car_sell_pay_count =
      "฿" + NumberUtil.addCommas(String(car_sell_pay_with_vat)); //ยอดเงิน
    let vat_bath_str = "฿" + NumberUtil.addCommas(String(vat_bath));

    let car_brand_name = car_sell_pay.car_brand_name;
    let car_model_name = car_sell_pay.car_model_name;

    let car_name2 = car_brand_name + " " + car_model_name;

    let billDetail =
      car_sell_list_pay +
      "  " +
      car_name +
      "  " +
      "สี" +
      car_color_name +
      "\n " +
      "ทะเบียนรถ " +
      car_license_plate +
      " " +
      "จังหวัด" +
      province_name +
      " \n" +
      "การชำระเงิน  :  " +
      sales_type;

    if (port === 9048) {
      billDetail =
        car_sell_list_pay +
        "  " +
        car_name2 +
        "  " +
        "ปี " +
        car_year_name +
        " " +
        "สี" +
        car_color_name +
        "\n " +
        "ทะเบียนรถ " +
        car_license_plate +
        " " +
        "จังหวัด" +
        province_name +
        " \n" +
        "การชำระเงิน  :  " +
        sales_type;
    }

    let moneyText = ThaiBaht(car_sell_pay_with_vat);

    let contentInfo = [];

    let billHeader = { text: bill_title, style: "bodyhead", lineHeight: 1.3 };
    let line1 = {
      columns: [
        {
          width: "20%",
          text: "",
          style: "bodycompany",
        },
        {
          width: "40%",
          style: "bodycompany",
          text: "",
        },
        {
          width: "15%",
          text: "เลขที่ใบเสร็จ :",
          style: "bodycompany",
        },
        {
          width: "40%",
          style: "bodycompany",
          text: doc_no,
        },
      ],
      columnGap: 20,
      lineHeight: 1,
    };

    let line2 = {
      columns: [
        {
          width: "20%",
          text: "",
          style: "bodycompany",
        },
        {
          width: "40%",
          style: "bodycompany",
          text: "",
        },
        {
          width: "15%",
          text: "วันที่ออกใบเสร็จ :",
          style: "bodycompany",
        },
        {
          width: "40%",
          style: "bodycompany",
          text: date_pay,
        },
      ],
      columnGap: 20,
      lineHeight: 1,
    };

    let line3 = {
      columns: [
        {
          width: "15%",
          text: "ผู้ประกอบธุรกิจ :",
          style: "bodycompany",
        },
        {
          width: "45%",
          style: "bodycompany",
          text: car_brance,
        },
        {
          width: "15%",
          text: "เลขที่ผู้เสียภาษี :",
          style: "bodycompany",
        },
        {
          width: "40%",
          style: "bodycompany",
          text: juristic_number,
        },
      ],
      columnGap: 20,
      lineHeight: 1,
    };

    let line4 = {
      columns: [
        {
          width: "14%",
          text: "สถานที่ตั้ง :",
          style: "bodycompany",
        },
        {
          width: "86%",
          style: "bodycompany",
          text: car_brance_address,
        },
      ],
      columnGap: 20,
      lineHeight: 1,
    };

    let line5 = {
      columns: [
        {
          width: "15%",
          text: "เบอร์โทรศัพท์ :",
          style: "bodycompany",
        },
        {
          width: "45%",
          style: "bodycompany",
          text: car_brance_tel,
        },
        {
          width: "15%",
          text: "ผู้พิมพ์ใบเสร็จ :",
          style: "bodycompany",
        },
        {
          width: "25%",
          style: "bodycompany",
          text: person_transaction,
        },
      ],
      columnGap: 20,
      lineHeight: 1.3,
    };

    let line6 = {
      columns: [
        {
          width: "15%",
          text: "ชื่อ-สกุลลูกค้า :",
          style: "bodycompany",
        },
        {
          width: "45%",
          style: "bodycompany",
          text: customer_name + "   " + customer_lastname,
        },
        {
          width: "15%",
          text: "เบอร์โทรศัพท์ :",
          style: "bodycompany",
        },
        {
          width: "25%",
          style: "bodycompany",
          text: customer_mobile,
        },
      ],
      columnGap: 20,
      lineHeight: 1.2,
    };

    let line7 = {
      columns: [
        {
          width: "14%",
          text: "ที่อยู่ :",
          style: "bodycompany",
        },
        {
          width: "86%",
          style: "bodycompany",
          text: customer_address,
        },
      ],
      columnGap: 20,
      lineHeight: 1.2,
    };

    let tableDetail = {
      table: {
        headerRows: 2,
        widths: [30, "*", 70, 80],
        heights: [20, 20],
        body: [
          [
            { text: "ลำดับ", style: "myCell" },
            { text: "รายการ", style: "myCell" },
            { text: "ราคา/หน่วย", style: "myCell" },
            { text: "รวมราคา", style: "myCell" },
          ],
          [
            { text: "1", style: "myCellDetail" },
            {
              text: billDetail,
              style: "body",
            },
            { text: car_sell_pay_no_vat_str, style: "myCellPrice" },
            { text: car_sell_pay_no_vat_str, style: "myCellSumPrice" },
          ],
        ],
      },
      columnGap: 20,
    };

    let tableVat = {
      table: {
        headerRows: 1,
        widths: ["*", 80],
        heights: [20],
        body: [
          [
            { text: "ภาษีมูลค่าเพิ่ม", style: "myCellSumTextRight" },
            {
              text: vat_bath_str,
              style: "myCellSumCost",
            },
          ],
        ],
      },
      columnGap: 20,
    };

    let tableVatZero = {
      table: {
        headerRows: 1,
        widths: ["*", 80],
        heights: [20],
        body: [
          [
            { text: "ภาษีมูลค่าเพิ่ม", style: "myCellSumTextRight" },
            {
              text: "-",
              style: "myCellSumCost",
            },
          ],
        ],
      },
      columnGap: 20,
    };

    let tableTotal = {
      table: {
        headerRows: 1,
        widths: ["*", 80],
        heights: [20],
        body: [
          [
            /*{
              text: 'รวมราคาทั้งสิ้น   ' + moneyText,
              style: 'myCellSumTextCost'
            },*/
            {
              columns: [
                {
                  width: "80%",
                  style: "myCellSumTextCost",
                  text: "รวมราคาทั้งสิ้น(ตัวอักษร)   " + moneyText,
                },
                {
                  width: "20%",
                  style: "myCellSumTextCostNum",
                  text: "รวมทั้งสิ้น",
                },
              ],
              style: "myCellSumTextCostNum",
              /*table: {
                widths: ['*', 100],
                body: [
                  [
                    {
                      text: 'รวมราคาทั้งสิ้น(ตัวอักษร)   ' + moneyText,
                      style: 'myCellSumTextCost'
                    },
                    {text: 'รวมทั้งสิ้น', style: 'myCellSumTextRight'},
                  ]
                ]
              }*/
            },
            {
              text: car_sell_pay_count,
              style: "myCellSumTextCostNum",
            },
          ],
        ],
      },
      columnGap: 20,
      lineHeight: 1,
    };

    contentInfo.push(billHeader);
    contentInfo.push(line1);
    contentInfo.push(line2);
    contentInfo.push(line3);
    contentInfo.push(line4);
    contentInfo.push(line5);
    contentInfo.push(line6);
    contentInfo.push(line7);
    contentInfo.push(tableDetail);

    if (vat !== 0) {
      contentInfo.push(tableVat);
    } else {
      contentInfo.push(tableVatZero);
    }

    contentInfo.push(tableTotal);

    let contentInfoCopy = JSON.parse(JSON.stringify(contentInfo));

    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [25, 25, 25, 0],
      background: { image: "book", width: 600 },
      content: [
        contentInfo,
        [
          { text: "   " },
          { text: "   " },
          { text: "   " },
          { text: "   " },
          { text: "   " },
          { text: "   " },
          { text: "   " },
          contentInfoCopy,
        ],
      ],
      images: {
        book: "data:image/png;base64,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",
      },
      styles: {
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 14,
          fillColor: "#BEBEBE",
          alignment: "center",
          bold: true,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: "center",
        },
        myCellPrice: {
          fontSize: 14,
          alignment: "right",
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "left",
          bold: true,
        },
        myCellSumTextRight: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "right",
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "right",
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "left",
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "right",
          bold: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  onInsuranceBuyChanged(e) {
    let insurance_buy = e.currentTarget.value;
    this.setState(
      {
        insurance_buy: insurance_buy,
      },
      () => {
        this.handleOnChangeCarPriceOutof();
      }
    );
  }

  onInsurancePABuyChanged(e) {
    let insurance_pa_buy = e.currentTarget.value;
    this.setState(
      {
        insurance_pa_buy: insurance_pa_buy,
      },
      () => {
        this.handleOnChangeCarPriceOutof();
      }
    );
  }

  /*onRefundTypeChange(e) {
    let refund_type = e.currentTarget.value
    this.setState({
      refund_type: refund_type
    });
  }*/

  toggleAgentModal(status, agent) {
    this.setState({
      isAgentModal: status,
    });

    if (agent !== null) {
      const agent_id = agent.agent_id;
      this.setState({
        agent_id: agent_id,
        agentSelected: agent,
      });
    }
  }

  renderInput(name, lable, form_controls) {
    let value = this.state[name];

    let col = "form-group col-sm-2";
    let displayType = "input";
    if (name === "total_outof_discount") {
      col = "form-group col-sm-2";
      let total_outof_car = Number(this.state.total_outof_car);
      if (total_outof_car === 0) {
        displayType = "text";
      }
    }

    return (
      <div className={checkFormControls(name, form_controls) ? col : "hidden"}>
        <label htmlFor={name}>{lable}</label>
        <NumberFormat
          className="form-control"
          thousandSeparator={true}
          displayType={displayType}
          prefix={"฿"}
          min={0}
          max={1000000000}
          step={1000}
          size={10}
          allowNegative={false}
          value={value}
          onValueChange={(values) => {
            const { value } = values;
            this.setState(
              {
                [name]: value,
              },
              () => {
                if (name === "total_outof_discount") {
                  this.handleOnChangeCarPriceOutof();
                }
              }
            );
          }}
        />
      </div>
    );
  }

  renderInputWithCalVatFinance(name, lable, form_controls) {
    return (
      <div
        className={
          checkFormControls(name, form_controls)
            ? "form-group col-sm-2"
            : "hidden"
        }
      >
        <label htmlFor={name}>{lable}</label>
        <button
          className="ml-1"
          type="button"
          onClick={() => {
            let tax_invoice_amount =
              this.state.tax_invoice_amount === ""
                ? 0
                : Number(this.state.tax_invoice_amount);
            let vat = tax_invoice_amount * this.state.vatPercent;
            let vat_fix = parseFloat(String(vat)).toFixed(2);

            this.setState({
              tax_invoice_vat: vat_fix,
            });
          }}
        >
          คำนวณ
        </button>
        <NumberFormat
          className="form-control"
          thousandSeparator={true}
          prefix={"฿"}
          min={0}
          max={1000000000}
          step={1000}
          size={10}
          allowNegative={false}
          value={this.state.tax_invoice_vat}
          onValueChange={(values) => {
            const { value } = values;
            this.setState({
              [name]: value,
            });
          }}
        />
      </div>
    );
  }

  renderInputWithCalVatCommission(name, lable, form_controls) {
    return (
      <div
        className={
          checkFormControls(name, form_controls)
            ? "form-group col-sm-2"
            : "hidden"
        }
      >
        <label htmlFor={name}>{lable}</label>
        <button
          className="ml-1"
          type="button"
          onClick={() => {
            let tax_commission_amount =
              this.state.tax_commission_amount === ""
                ? 0
                : Number(this.state.tax_commission_amount);
            let vat = tax_commission_amount * this.state.vatPercent;
            let vat_fix = parseFloat(String(vat)).toFixed(2);

            this.setState({
              tax_commission_vat: vat_fix,
            });
          }}
        >
          คำนวณ
        </button>
        <NumberFormat
          className="form-control"
          thousandSeparator={true}
          prefix={"฿"}
          min={0}
          max={1000000000}
          step={1000}
          size={10}
          allowNegative={false}
          disabled={this.state.is_no_commission === 1}
          value={this.state.tax_commission_vat}
          onValueChange={(values) => {
            const { value } = values;
            this.setState({
              [name]: value,
            });
          }}
        />
      </div>
    );
  }

  //ta--sc
  toggleAddCustomerNewModal(customer) {
    let isClose = !this.state.isAddCustomerNewModal;
    if (customer === null) {
      this.setState({
        isAddCustomerNewModal: isClose,
      });
    } else {
      this.setState(
        {
          isAddCustomerNewModal: isClose,
          customer_select: true,
          customer: customer,
          customer_id: customer.customer_id,
        },
        () => {
          this.loadDataCarSellPay();
        }
      );
    }
  }

  resetCustomerSelect() {
    this.refs.search_customer_name.value = "";

    this.setState({
      customer_select: false,
      customer: {},
      customer_id: "",
      customer_list: [],
    });
  }

  toggleAddCustomer() {
    let isClose = !this.state.isAddCustomerNewModal;
    this.setState({
      isAddCustomerNewModal: isClose,
    });
  }

  calTotalOutOfCarWithDiscount() {
    let total_outof_car = Number(this.state.total_outof_car);
    let total_outof_discount = Number(this.state.total_outof_discount);

    if (total_outof_discount > total_outof_car) {
      AlertError("ยอดส่วนลดเงินออกรถ > ยอดรวมออกรถ กรุณาตรวจสอบ");
      return;
    }

    if (
      this.state.total_outof_car === "" ||
      this.state.total_outof_car === "0" ||
      this.state.total_outof_car === 0
    ) {
      return;
    }

    if (
      this.state.total_outof_discount === "" ||
      this.state.total_outof_discount === "0" ||
      this.state.total_outof_discount === 0
    ) {
      return;
    }

    let total_outof_car_fix = Number(total_outof_car.toFixed(2));
    let total_outof_discount_fix = Number(total_outof_discount.toFixed(2));

    let total_outof_car2 = total_outof_car_fix - total_outof_discount_fix;
    let total_outof_car2_fix = total_outof_car2.toFixed(2);

    // this.setState({
    //   total_outof_car: total_outof_car2_fix
    // })
  }

  render() {
    let car = this.state.car;
    let car_sell_type_id = this.state.car_sell_type_id;
    let form_controls = this.state.form_controls;
    const { width, height } = this.state;

    // let fullname = this.state.user.fullname
    let tax_invoice_amount_label =
      car_sell_type_id === "1" ? "ค่าตัวรถ" : "ยอดจัด";
    let tax_invoice_vat_label =
      car_sell_type_id === "1" ? "VAT ของตัวรถ" : "VAT ของยอดจัด";

    let search_customer_list = this.state.customer_list.map(
      (customer_list, index) => {
        return (
          <tr key={index}>
            <td>
              <strong>ชื่อ</strong> &nbsp;&nbsp; {customer_list.customer_name}
            </td>
            <td>
              <strong>นามสกุล</strong> &nbsp;&nbsp;{" "}
              {customer_list.customer_lastname}
            </td>
            <td>
              <strong>เลขประจำตัวประชาชน</strong> &nbsp;&nbsp;{" "}
              {customer_list.customer_card_id}
            </td>
            <td>
              <strong>เบอร์โทรศัพท์</strong> &nbsp;&nbsp;{" "}
              {customer_list.customer_mobile}
            </td>
            <td>
              <button
                onClick={() => this.onCustomerSelect(customer_list, this)}
                type="button"
                className="btn btn-primary"
              >
                <i className="fa fa-hand-pointer-o" />
                &nbsp;&nbsp; เลือก
              </button>
            </td>
          </tr>
        );
      }
    );

    let car_sell_pay_tr = this.state.car_sell_pay_list.map(
      (car_sell_pay, index) => {
        return (
          <tr key={index}>
            <td className="text-center">
              วันที่: {car_sell_pay.date_pay}
              <br />
              {car_sell_pay.doc_no !== null ? (
                <>เลขที่ : {car_sell_pay.doc_no}</>
              ) : (
                ""
              )}
              {/*(#{car_sell_pay.car_sell_pay_id})*/}
            </td>
            <td className="text-center">
              {car_sell_pay.car_sell_list_pay_name}
            </td>

            <td className="text-center">
              <NumberFormat
                value={car_sell_pay.car_sell_pay_count}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"฿"}
              />

              {car_sell_pay.vat !== 0 ? (
                <>
                  <br />
                  {car_sell_pay.include_vat === 1
                    ? "*ยอดรวม vat"
                    : "*ยอดไม่รวม vat"}
                </>
              ) : (
                ""
              )}
            </td>

            <td className="text-center">
              ชำระโดย : {car_sell_pay.sales_type_name}
              <br />
              ช่องทางรับชำระ : {car_sell_pay.bank_name}
            </td>

            <td className="text-center">
              {car_sell_pay.pay_image1 !== null ? (
                <>
                  <img
                    src={car_sell_pay.pay_image1}
                    style={{
                      cursor: "pointer",
                      width: "60px",
                      height: "60px",
                    }}
                    onClick={() =>
                      this.onPreviewSelected(car_sell_pay.pay_image1)
                    }
                    alt="แนบสลิป 1"
                  />
                </>
              ) : null}

              {car_sell_pay.pay_image2 !== null ? (
                <>
                  <img
                    src={car_sell_pay.pay_image2}
                    style={{
                      cursor: "pointer",
                      width: "60px",
                      height: "60px",
                    }}
                    onClick={() =>
                      this.onPreviewSelected(car_sell_pay.pay_image2)
                    }
                    alt="แนบสลิป 2"
                  />
                </>
              ) : null}
              <br />
              {car_sell_pay.pay_image3 !== null ? (
                <>
                  <br />
                  <img
                    src={car_sell_pay.pay_image3}
                    style={{
                      cursor: "pointer",
                      width: "60px",
                      height: "60px",
                    }}
                    onClick={() =>
                      this.onPreviewSelected(car_sell_pay.pay_image3)
                    }
                    alt="แนบสลิป 3"
                  />
                </>
              ) : null}

              {car_sell_pay.pay_image4 !== null ? (
                <>
                  <img
                    src={car_sell_pay.pay_image4}
                    style={{
                      cursor: "pointer",
                      width: "60px",
                      height: "60px",
                    }}
                    onClick={() =>
                      this.onPreviewSelected(car_sell_pay.pay_image4)
                    }
                    alt="แนบสลิป 4"
                  />
                </>
              ) : null}
            </td>
            <td className="text-center">
              {car_sell_pay.person_transaction}
              <br />
              {moment(car_sell_pay.updated_at)
                .locale("th")
                .format("DD-MM-YYYY HH:mm:ss")}
            </td>
            <td className="text-center">
              <button
                onClick={() => {
                  this.printOcpb(car_sell_pay);
                }}
                type="button"
                className="btn btn-primary"
              >
                <i className="icon-printer" />
              </button>
            </td>
          </tr>
        );
      }
    );

    let bank_pay_list = this.state.banks.map((bank, index) => {
      return (
        <option key={index} value={bank.bank_id}>
          {bank.bank_name}
        </option>
      );
    });

    let bank_finance_list = this.state.bank.map((bank, index) => {
      return (
        <option key={index} value={bank.bank_id}>
          {bank.bank_name}
        </option>
      );
    });

    let car_sell_type_list = this.state.car_sell_type.map(
      (car_sell_type, index) => {
        return (
          <option key={index} value={car_sell_type.car_sell_type_id}>
            {car_sell_type.car_sell_type_name}
          </option>
        );
      }
    );

    let insurance_company_list = this.state.insurance_company.map(
      (insurance_company, index) => {
        return (
          <option key={index} value={insurance_company.insurance_company_id}>
            {insurance_company.insurance_company_name}
          </option>
        );
      }
    );

    let insurance_type_list = this.state.insurance_type.map(
      (insurance_type, index) => {
        return (
          <option key={index} value={insurance_type.insurance_type_id}>
            {insurance_type.insurance_type_name}
          </option>
        );
      }
    );

    /*var count_period_list = this.state.count_period.map((count_period, index) => {
      return (
        <option key={index}
                value={count_period.count_period_id}>{count_period.count_period_name}</option>
      )
    })*/

    let duration_period_list = this.state.duration_period.map(
      (duration_period, index) => {
        return (
          <option key={index} value={duration_period.duration_period_id}>
            {duration_period.duration_period_name}
          </option>
        );
      }
    );

    let car_sell_list_pay_list = this.state.car_sell_list_pay.map(
      (car_sell_list_pay, index) => {
        return (
          <option key={index} value={car_sell_list_pay.car_sell_list_pay_id}>
            {car_sell_list_pay.car_sell_list_pay_name}
          </option>
        );
      }
    );

    let car_sell_status_list = this.state.car_status.map(
      (car_status, index) => {
        return (
          <option key={index} value={car_status.car_status_id}>
            {car_status.car_status_name}
          </option>
        );
      }
    );

    let sales_type_list = this.state.sales_type.map((sales_type, index) => {
      return (
        <option key={index} value={sales_type.sales_type_id}>
          {sales_type.sales_type_name}
        </option>
      );
    });

    let promotion_list = this.state.promotion_list.map((promotion, index) => {
      return (
        <option key={index} value={promotion.promotion_name}>
          {" "}
          {promotion.promotion_name}{" "}
        </option>
      );
    });

    let employee_list = this.state.employees.map((employee, index) => {
      return (
        <option key={index} value={employee.employee_id}>
          {" "}
          {employee.employee_name}&nbsp;&nbsp;{employee.employee_lastname}{" "}
        </option>
      );
    });

    /*let obj_photo;

     */
    let gearbox_warranty_list = this.state.gearbox_warranty_list.map(
      (gearbox_warranty, index) => {
        return (
          <option key={index} value={gearbox_warranty.gearbox_warranty_name}>
            {" "}
            {gearbox_warranty.gearbox_warranty_name}{" "}
          </option>
        );
      }
    );

    let more_detail_list = this.state.more_detail.map((more_detail, index) => {
      return (
        <option key={index} value={more_detail.more_detail_id}>
          {more_detail.more_detail_name}
        </option>
      );
    });

    let liciense_status = this.state.liciense_status.map(
      (liciense_status, index) => {
        return (
          <option key={index} value={liciense_status.liciense_status_id}>
            {liciense_status.liciense_status_name}
          </option>
        );
      }
    );

    return (
      <div className="card">
        <AgentModal
          isAgentModal={this.state.isAgentModal}
          toggleAgentModal={this.toggleAgentModal}
        />

        {/*ta--sc*/}
        {this.state.isAddCustomerNewModal && (
          <Modal
            isOpen={this.state.isAddCustomerNewModal}
            toggle={this.toggleAddCustomer}
            className={"modal-lg " + this.props.className}
            style={width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }}
          >
            <ModalBody>
              <CustomerForm
                onToggle={this.toggleAddCustomerNewModal}
                username={this.state.user.user}
              />
            </ModalBody>
          </Modal>
        )}

        <Modal
          isOpen={this.state.preview_image_select}
          toggle={this.togglePreviewImage}
          className={"modal-lg "}
        >
          <ModalBody>
            <PreviewImage imageUrl={this.state.preview_image_url} />
          </ModalBody>
        </Modal>

        <div className="card-block">
          <form action="" method="post" onSubmit={this.handleOnSubmitSell}>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">
                      เพิ่มรายละเอียดการขายรถ
                    </strong>
                  </div>

                  <div className="card-block">
                    <div className="row" style={styles.bottomLine}>
                      <div className="col-lg-12">
                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> ชื่อรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-3">
                            <strong> ยี่ห้อ </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_brand_name} </strong>
                            </p>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3 ">
                            <strong> รุ่นรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_model_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-3">
                            <strong> รุ่นย่อย </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_sub_model_name} </strong>
                            </p>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ปีรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_year_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-3">
                            <strong> ระบบเกียร์ </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_gear_name} </strong>
                            </p>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> สีรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_color_name} </strong>
                            </p>
                          </div>

                          <label className="col-md-3">
                            <strong> เลขไมล์ </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_miles} </strong>
                            </p>
                          </div>
                        </div>

                        <div
                          className=" form-group row"
                          style={styles.bottomLine}
                        >
                          <label className="col-md-3">
                            <strong> ป้ายทะเบียนรถ </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.car_license_plate_new} </strong>
                            </p>
                          </div>

                          <label className="col-md-3">
                            <strong> จังหวัด </strong>
                          </label>
                          <div className="col-md-3">
                            <p className="text-justify text-primary">
                              <strong> {car.province_name_new} </strong>
                            </p>
                          </div>
                        </div>

                        <div
                          className={
                            !this.state.customer_select ? "row " : " hidden"
                          }
                        >
                          <div className="controls col-md-12">
                            <div className="input-group has-success ">
                              <input
                                onChange={this.searchCustomer.bind(this)}
                                ref="search_customer_name"
                                placeholder="ค้นหาชื่อลูกค้า"
                                className="form-control"
                                size="16"
                                type="text"
                              />

                              <span className="input-group-btn ">
                                <button
                                  className="btn btn-success"
                                  type="button"
                                  onClick={this.searchCustomer.bind(this)}
                                >
                                  ค้นหา
                                </button>
                              </span>

                              {/*เต็นท์ sc ขอเพิ่ม*/}
                              <button
                                className="btn btn-info ml-3"
                                name="customer_find"
                                type="button"
                                //style={styles.buttonHeight}
                                onClick={() =>
                                  this.toggleAddCustomerNewModal(null)
                                }
                              >
                                เพิ่มลูกค้าใหม่
                              </button>
                            </div>

                            <div id="show_customer" className="row">
                              <div className="controls col-md-12">
                                <table className="table table-striped">
                                  <tbody>{search_customer_list}</tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={
                            this.state.customer_select ? "row " : " hidden"
                          }
                        >
                          <div className="card-header controls col-md-12 hidden ">
                            <strong>ข้อมูลลูกค้า</strong>
                          </div>

                          <div className="card-block has-success">
                            <div className="row">
                              <div className="col-lg-12">
                                <div
                                  className=" form-group row"
                                  style={styles.bottomLine}
                                >
                                  <label className="col-md-3">
                                    <strong> ชื่อลูกค้า </strong>
                                  </label>
                                  <div className="col-md-3">
                                    <p className="text-justify text-success ">
                                      <strong>
                                        {this.state.customer.customer_name}
                                      </strong>
                                    </p>
                                  </div>

                                  <label className="col-md-3">
                                    <strong> นามสกุล </strong>
                                  </label>
                                  <div className="col-md-2">
                                    <p className="text-justify text-success">
                                      <strong>
                                        {" "}
                                        {
                                          this.state.customer.customer_lastname
                                        }{" "}
                                      </strong>
                                    </p>
                                  </div>

                                  <div className="col-md-1">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => this.resetCustomerSelect()}
                                    >
                                      <i className="fa fa-refresh" />
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div
                                  className=" form-group row"
                                  style={styles.bottomLine}
                                >
                                  <label className="col-md-3">
                                    <strong>เลขบัตรประชาชน </strong>
                                  </label>
                                  <div className="col-md-3">
                                    <p className="text-justify text-success">
                                      <strong>
                                        {this.state.customer.customer_card_id}
                                      </strong>
                                    </p>
                                  </div>

                                  <label className="col-md-3">
                                    <strong>เบอร์โทรศัพท์ </strong>
                                  </label>
                                  <div className="col-md-3">
                                    <p className="text-justify text-success">
                                      <strong>
                                        {" "}
                                        {
                                          this.state.customer.customer_mobile
                                        }{" "}
                                      </strong>
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div
                                  className=" form-group row"
                                  style={styles.bottomLine}
                                >
                                  <label className="col-md-3">
                                    <strong>ที่อยู่ปัจจุบัน </strong>
                                  </label>
                                  <div className="col-md-9">
                                    <p className="text-justify text-success">
                                      <strong>
                                        {this.state.customer.customer_address}
                                      </strong>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="form-group col-sm-12">
                            <label htmlFor="car_sell_type">ขายโดย</label>

                            <SelectSearch
                              ref="sale_by_id"
                              options={this.state.employees}
                              value={this.state.sale_by_id}
                              search={true}
                              name="sale_by_id"
                              placeholder="เลือกผู้ขาย"
                              onChange={(val) => {
                                //let employees = this.state.employees
                                //let income_expense = employees.filter(item => item.employee_id === val)
                                //let income_expense_item_name = income_expense[0].income_expense_item_name

                                this.setState({
                                  sale_by_id: val,
                                });
                              }}
                            />
                            {/*<select
                              className="form-control"
                              id="sale_by_id"
                              name="sale_by_id"
                              onChange={(e) => {
                                this.setState({
                                  sale_by_id: e.target.value
                                })
                              }}
                            >
                              <option value=''> เลือกพนักงานผู้ขาย </option>
                              {employee_list}
                            </select>*/}
                          </div>
                        </div>

                        <div className="row">
                          <div className="form-group col-sm-4">
                            <label htmlFor="car_sell_type">ประเภทการขาย</label>
                            <select
                              className="form-control"
                              id="car_sell_type_id"
                              name="car_sell_type_id"
                              onChange={this.carSalesTypeChange.bind(this)}
                            >
                              <option value=""> เลือกประเภทการขาย</option>
                              {car_sell_type_list}
                            </select>
                          </div>
                          <div className="form-group col-sm-4">
                            <label htmlFor="bank_finance_id">ไฟแนนซ์</label>
                            <select
                              className="form-control"
                              id="bank_finance_id"
                              name="bank_finance_id"
                              ref="bank_finance_id"
                              disabled={this.state.car_sell_type_id === "1"}
                            >
                              <option value=""> เลือกธนาคาร</option>
                              {bank_finance_list}
                            </select>
                          </div>
                          <div className="form-group col-sm-4">
                            <label htmlFor="sell_finance_contract">
                              ชื่อพนักงานไฟแนนซ์
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="sell_finance_contract"
                              name="sell_finance_contract"
                              placeholder=""
                              ref="sell_finance_contract"
                              maxLength={100}
                              value={this.state.sell_finance_contract}
                              disabled={this.state.car_sell_type_id === "1"}
                              onChange={(e) => {
                                this.setState({
                                  sell_finance_contract: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="form-group col-sm-3">
                            <label htmlFor="normal_sell_price">ราคาปกติ</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="normal_sell_price"
                              name="normal_sell_price"
                              placeholder=""
                              ref="normal_sell_price"
                              value={this.state.normal_sell_price}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-primary"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.normal_sell_price}
                              displayType="text"
                            />
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="real_sell_price">ราคาขายจริง</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="real_sell_price"
                              name="real_sell_price"
                              placeholder=""
                              ref="real_sell_price"
                              value={this.state.real_sell_price}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.real_sell_price}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState(
                                  { real_sell_price: value },
                                  () => {
                                    this.handleOnChangeCarPrice();
                                  }
                                );
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2 has-warning">
                            <label htmlFor="car_over_sales">ยอดขายเกิน</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="car_over_sales"
                              name="car_over_sales"
                              placeholder=""
                              ref="car_over_sales"
                              value={this.state.car_over_sales}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-primary"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={true}
                              value={this.state.car_over_sales}
                              displayType="text"
                            />
                          </div>

                          <div className="form-group col-sm-2 has-warning">
                            <label htmlFor="car_sell_discount">ส่วนลด</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="car_sell_discount"
                              name="car_sell_discount"
                              placeholder=""
                              ref="car_sell_discount"
                              value={this.state.car_sell_discount}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-primary"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder="กรอกค่าโอน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={true}
                              value={this.state.car_sell_discount}
                              displayType="text"
                            />
                          </div>

                          <div className="form-group col-sm-2 has-success">
                            <label htmlFor="car_sell_discount">เงินจอง</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="sum_car_books"
                              name="sum_car_books"
                              placeholder=""
                              value={this.state.sum_car_books}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-success"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder="กรอกค่าโอน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={true}
                              value={this.state.sum_car_books}
                              displayType="text"
                            />
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="rate_finance">ยอดจัดไฟแนนซ์</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="rate_finance"
                              name="rate_finance"
                              placeholder=""
                              ref="rate_finance"
                              value={this.state.rate_finance}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              disabled={this.state.car_sell_type_id === "1"}
                              onValueChange={(values) => {
                                const { value } = values;

                                this.setState(
                                  {
                                    rate_finance: value,
                                    is_key_vat_down: false,
                                  },
                                  () => {
                                    this.handleOnChangeCarPrice();
                                  }
                                );
                              }}
                            />
                          </div>

                          <div
                            className={
                              checkFormControls("sell_discount", form_controls)
                                ? "form-group col-sm-2"
                                : "hidden"
                            }
                          >
                            <label htmlFor="sell_discount">
                              ส่วนลดเงินดาวน์
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="sell_discount"
                              name="sell_discount"
                              placeholder=""
                              ref="sell_discount"
                              value={this.state.sell_discount}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              displayType={
                                this.state.sum_down === 0 ? "text" : "input"
                              }
                              allowNegative={false}
                              value={this.state.sell_discount}
                              disabled={this.state.car_sell_type_id === "1"}
                              onValueChange={(values) => {
                                const { value } = values;

                                this.setState(
                                  {
                                    sell_discount: value,
                                    is_key_vat_down: false,
                                  },
                                  () => {
                                    this.handleOnChangeCarPrice();
                                  }
                                );
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2 has-warning">
                            <label htmlFor="sum_down">ยอดดาวน์</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="sum_down"
                              name="sum_down"
                              placeholder=""
                              ref="sum_down"
                              value={this.state.sum_down}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-primary"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.sum_down}
                              displayType="text"
                              disabled={this.state.car_sell_type_id === "1"}
                            />
                          </div>

                          <div
                            className={
                              this.state.is_vat === 1 && PORT !== 9048
                                ? "form-group col-sm-2"
                                : "hidden"
                            }
                          >
                            <label htmlFor="vat_down">VAT เงินดาวน์</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="vat_down"
                              name="vat_down"
                              placeholder=""
                              value={this.state.vat_down}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-primary"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.vat_down}
                              disabled={this.state.car_sell_type_id === "1"}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState(
                                  {
                                    vat_down: value,
                                    is_key_vat_down: true,
                                  },
                                  () => {
                                    this.handleOnChangeCarPrice();
                                  }
                                );
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2 has-warning">
                            <label htmlFor="car_excess_amount">
                              ยอดจัดเกิน
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="car_excess_amount"
                              name="car_excess_amount"
                              placeholder=""
                              ref="car_excess_amount"
                              value={this.state.car_excess_amount}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-primary"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder=""
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.car_excess_amount}
                              displayType="text"
                              disabled={this.state.car_sell_type_id === "1"}
                            />
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="insurance_company_id">
                              บ.ประกันรถ
                            </label>
                            <select
                              className="form-control"
                              id="insurance_company_id"
                              name="insurance_company_id"
                              onChange={() => {}}
                            >
                              <option value=""> เลือก บ.ประกันรถ</option>
                              {insurance_company_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="insurance_type">
                              ประเภทประกันรถ
                            </label>
                            <select
                              className="form-control"
                              id="insurance_type_id"
                              name="insurance_type_id"
                              onChange={() => {}}
                            >
                              <option> เลือกประเภทประกันรถ</option>
                              {insurance_type_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="insurance_price">ราคาประกัน</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="insurance_price"
                              name="insurance_price"
                              placeholder=""
                              ref="insurance_price"
                              value={this.state.insurance_price}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder=""
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState(
                                  { insurance_price: value },
                                  () => {
                                    this.handleOnChangeCarPriceOutof();
                                  }
                                );
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="insurance_buy">
                              ประกันรถ แถม/ซื้อเอง
                            </label>
                            <br />
                            <input
                              type="radio"
                              name="insurance_buy"
                              value="ประกันแถม"
                              className="btn btn-primary"
                              defaultChecked={
                                this.state.insurance_buy === "ประกันแถม"
                              }
                              onChange={this.onInsuranceBuyChanged}
                            />{" "}
                            &nbsp;
                            <span style={{ marginTop: -4 }}>ประกันแถม</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              type="radio"
                              name="insurance_buy"
                              value="ซื้อเอง"
                              className="btn btn-primary"
                              defaultChecked={
                                this.state.insurance_buy === "ซื้อเอง"
                              }
                              onChange={this.onInsuranceBuyChanged}
                            />{" "}
                            &nbsp;<span style={{ marginTop: -4 }}>ซื้อเอง</span>
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="insurance_pa">
                              เก็บค่าประกันชีวิต PA
                              {port === 9005 ? (
                                <>
                                  &nbsp; &nbsp;
                                  <input
                                    type="checkbox"
                                    name="is_insurance_pa"
                                    className="mr-1"
                                    value={this.state.is_insurance_pa}
                                    checked={this.state.is_insurance_pa === 1}
                                    onChange={(e) => {
                                      /*let val = Number(e.target.value)

                                           if (val === 1) {
                                             this.setState({
                                               is_insurance_pa: 0
                                             })
                                           } else if (val === 0){
                                             this.setState({
                                               is_insurance_pa: 1
                                             })
                                           }*/
                                    }}
                                  />{" "}
                                  ไม่รวมออกรถ
                                </>
                              ) : null}
                            </label>

                            <input
                              type="text"
                              className="form-control hidden"
                              id="insurance_pa"
                              name="insurance_pa"
                              ref="insurance_pa"
                              placeholder=""
                              value={this.state.insurance_pa}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              disabled={this.state.car_sell_type_id === "1"}
                              onValueChange={(values) => {
                                const { value } = values;

                                if (port === "9005" || port === 9005) {
                                  // pisan
                                  this.setState({ insurance_pa: value }); //values.floatValue
                                } else {
                                  this.setState({ insurance_pa: value }, () =>
                                    this.handleOnChangeCarPriceOutof()
                                  );
                                }
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="insurance_pa_buy">
                              ประกันชีวิต PA แถม/ซื้อเอง
                            </label>
                            <br />
                            <input
                              type="radio"
                              name="insurance_pa_buy"
                              value="PA แถม"
                              className="btn btn-primary"
                              defaultChecked={
                                this.state.insurance_pa_buy === "PA แถม"
                              }
                              onChange={this.onInsurancePABuyChanged}
                              disabled={this.state.car_sell_type_id === "1"}
                            />{" "}
                            &nbsp;<span style={{ marginTop: -4 }}>PA แถม</span>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <input
                              type="radio"
                              name="insurance_pa_buy"
                              value="PA ซื้อเอง"
                              className="btn btn-primary"
                              defaultChecked={
                                this.state.insurance_pa_buy === "PA ซื้อเอง"
                              }
                              onChange={this.onInsurancePABuyChanged}
                              disabled={this.state.car_sell_type_id === "1"}
                            />{" "}
                            &nbsp;
                            <span style={{ marginTop: -4 }}>PA ซื้อเอง</span>
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="pay_advance_finance">
                              เก็บค่างวดรถล่วงหน้า
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="pay_advance_finance"
                              name="pay_advance_finance"
                              placeholder=""
                              ref="pay_advance_finance"
                              value={this.state.pay_advance_finance}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder="กรอกค่าโอน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState(
                                  { pay_advance_finance: value },
                                  () => {
                                    this.handleOnChangeCarPriceOutof();
                                  }
                                );
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="duration_period">
                              ระยะเวลาผ่อนชำระ
                            </label>
                            <select
                              className="form-control"
                              id="duration_period_id"
                              name="duration_period_id"
                              ref="duration_period_id"
                              disabled={this.state.car_sell_type_id === "1"}
                              onChange={() => {}}
                            >
                              <option value=""> เลือกระยะเวลาผ่อนชำระ</option>
                              {duration_period_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="promotion_name">
                              ชื่อโปรโมชั่น
                            </label>
                            <select
                              className="form-control"
                              id="promotion_name"
                              name="promotion_name"
                              ref="promotion_name"
                            >
                              <option value=""> ระบุโปรโมชั่น </option>
                              {promotion_list}
                            </select>
                          </div>

                          {/*<div className="form-group col-sm-3">
                            <label htmlFor="cost_finance">ค่านายหน้า</label>
                            <input type="text"
                                   className="form-control hidden"
                                   id="car_external_commission"
                                   name="car_external_commission"
                                   placeholder=""
                                   ref="car_external_commission"
                                   value={this.state.car_external_commission}
                                   onChange={()=>{}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={'฿'}
                              //placeholder="กรอกค่าโอน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const {value} = values
                                this.setState({car_external_commission: value}, () => {
                                  //this.handleOnChangeCarPriceOutof()
                                })

                              }}
                            />
                          </div>*/}

                          <div className="form-group col-sm-2">
                            <label htmlFor="gearbox_warranty">
                              ประกันเครื่องเกียร์
                            </label>
                            <select
                              className="form-control"
                              id="gearbox_warranty"
                              name="gearbox_warranty"
                              value={this.state.gearbox_warranty}
                              onChange={(e) => {
                                let val = e.target.value;
                                this.setState(
                                  {
                                    gearbox_warranty: val,
                                  },
                                  () => {
                                    if (val === "ไม่รับประกันเครื่องเกียร์") {
                                      this.setState({
                                        gearbox_bank_name: "",
                                        gearbox_amount: 0,
                                      });
                                    }
                                  }
                                );
                              }}
                            >
                              <option value="">
                                {" "}
                                ระบุการประกันเครื่องเกียร์{" "}
                              </option>
                              {gearbox_warranty_list}
                            </select>
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="real_sell_price">
                              ยอดประกันเครื่องเกียร์
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="gearbox_amount"
                              placeholder=""
                              value={this.state.gearbox_amount}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder="กรอกค่าโอน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.gearbox_amount}
                              disabled={
                                this.state.gearbox_warranty !==
                                "รับประกันเครื่องเกียร์"
                              }
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState({ gearbox_amount: value }, () => {
                                  this.handleOnChangeCarPrice();
                                });
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="gearbox_bank_name">
                              ธ.ที่รับประกันเครื่องเกียร์{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="gearbox_bank_name"
                              name="gearbox_bank_name"
                              maxLength={100}
                              placeholder=""
                              value={this.state.gearbox_bank_name}
                              disabled={
                                this.state.gearbox_warranty !==
                                "รับประกันเครื่องเกียร์"
                              }
                              onChange={(event) => {
                                this.setState({
                                  gearbox_bank_name: event.target.value,
                                });
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="debt_insurance_amount">
                              ยอดประกันภาระหนี้
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="debt_insurance_amount"
                              placeholder=""
                              value={this.state.debt_insurance_amount}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder="กรอกค่าโอน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.debt_insurance_amount}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState(
                                  { debt_insurance_amount: value },
                                  () => {
                                    this.handleOnChangeCarPrice();
                                  }
                                );
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2">
                            <label
                              htmlFor="cost_finance"
                              style={{ fontSize: 12 }}
                            >
                              ค่าดำเนินการ/ค่าโอน/ค่าจัดไฟแนนซ์
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="cost_finance"
                              name="cost_finance"
                              placeholder=""
                              ref="cost_finance"
                              value={this.state.cost_finance}
                              onChange={() => {}}
                            />

                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder=""
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState({ cost_finance: value }, () => {
                                  this.handleOnChangeCarPriceOutof();
                                });
                              }}
                            />
                          </div>

                          <div className="form-group col-sm-2">
                            <label htmlFor="cost_sell_act">ค่า พรบ.</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="cost_sell_act"
                              name="cost_sell_act"
                              placeholder=""
                              ref="cost_sell_act"
                              value={this.state.cost_sell_act}
                              onChange={() => {}}
                            />

                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder=""
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values;
                                this.setState({ cost_sell_act: value }, () => {
                                  this.handleOnChangeCarPriceOutof();
                                });
                              }}
                            />
                          </div>

                          {this.renderInput(
                            "total_outof_discount",
                            "ส่วนลดเงินออกรถ",
                            form_controls
                          )}

                          <div className="form-group has-warning col-sm-2">
                            <label htmlFor="total_outof_car">
                              รวมออกรถ/บาท
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              name="total_outof_car"
                              placeholder=""
                              ref="total_outof_car"
                              value={this.state.total_outof_car}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-primary"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder="กรอกค่าโอน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.total_outof_car}
                              displayType="text"
                            />
                          </div>

                          <div className="form-group has-danger col-sm-2">
                            <label htmlFor="balance_debt">
                              ยอดคงเหลือค้างชำระ/บาท
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="balance_debt"
                              name="balance_debt"
                              placeholder=""
                              ref="balance_debt"
                              value={this.state.balance_debt}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-danger"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder="กรอกค่าโอน"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={true}
                              value={
                                this.state.balance_debt < 0
                                  ? 0
                                  : this.state.balance_debt
                              }
                              displayType="text"
                            />
                          </div>

                          <div
                            className={
                              checkFormControls("customer_cash", form_controls)
                                ? "form-group has-success col-sm-2"
                                : "hidden"
                            }
                          >
                            <label htmlFor="customer_cash">เงินคืนลูกค้า</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="customer_cash"
                              name="customer_cash"
                              placeholder=""
                              ref="customer_cash"
                              value={this.state.customer_cash}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control text-primary"
                              thousandSeparator={true}
                              prefix={"฿"}
                              //placeholder="เงินคืนลูกค้า"
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              value={this.state.customer_cash}
                              displayType="text"
                            />
                          </div>

                          <div
                            className={
                              checkFormControls("refund_type", form_controls)
                                ? "form-group col-sm-4"
                                : "hidden"
                            }
                          >
                            <label
                              className="radio-inline ml-3 mt-4"
                              htmlFor="refund_type1"
                            >
                              <input
                                type="radio"
                                id="refund_type1"
                                name="refund_type"
                                value="1"
                                checked={this.state.refund_type === 1}
                                className="btn btn-primary"
                                //onChange={this.onRefundTypeChange}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  this.setState({
                                    refund_type: parseInt(val),
                                    refund_inpart: 0,
                                  });
                                }}
                              />{" "}
                              &nbsp; คืนเงินเต็ม
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            <label
                              className="radio-inline ml-3 mt-4"
                              htmlFor="refund_type2"
                            >
                              <input
                                type="radio"
                                id="refund_type2"
                                name="refund_type"
                                value="2"
                                checked={this.state.refund_type === 2}
                                className="btn btn-primary"
                                //onChange={this.onRefundTypeChange}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  this.setState({
                                    refund_type: parseInt(val),
                                    refund_inpart: 0,
                                  });
                                }}
                              />{" "}
                              &nbsp; ไม่คืนเงิน
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            <label
                              className="radio-inline ml-3 mt-4"
                              htmlFor="refund_type3"
                            >
                              <input
                                type="radio"
                                id="refund_type3"
                                name="refund_type"
                                value="3"
                                checked={this.state.refund_type === 3}
                                className="btn btn-primary"
                                //onChange={this.onRefundTypeChange}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  this.setState({
                                    refund_type: parseInt(val),
                                  });
                                }}
                              />{" "}
                              &nbsp; คืนเงินบางส่วน
                            </label>
                          </div>

                          <div
                            className={
                              checkFormControls("refund_type", form_controls)
                                ? "form-group col-sm-2"
                                : "hidden"
                            }
                          >
                            <label htmlFor="refund_inpart">
                              เงินคืนลูกค้าบางส่วน
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="refund_inpart"
                              name="refund_inpart"
                              ref="refund_inpart"
                              value={this.state.refund_inpart}
                              onChange={() => {}}
                            />

                            <NumberFormat
                              className="form-control"
                              placeholder="กรอกเงินคืนลูกค้าบางส่วน"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              disabled={this.state.refund_type !== 3}
                              onValueChange={(values) =>
                                this.setState({
                                  refund_inpart: values.floatValue,
                                })
                              }
                              /*onValueChange={(values) => {
                                  const {value} = values
                                  this.setState({cost_finance: value}, () => {
                                    this.handleOnChangeCarPriceOutof()
                                  })

                                }}*/
                            />
                          </div>

                          {/*<div className={this.state.customer_cash === 0 ? 'hidden' : "form-group col-sm-3"}>*/}

                          <div className="form-group col-sm-3">
                            <label htmlFor="car_sell_status">สถานะ</label>
                            <select
                              className="form-control"
                              id="car_status_id"
                              name="car_status_id"
                              onChange={(e) => {
                                let value = Number(e.target.value);
                                this.setState({
                                  car_status_id: value,
                                });
                              }}
                            >
                              {car_sell_status_list}
                            </select>
                          </div>

                          {PORT === 9048 ? (
                            <>
                              <div className="form-group col-sm-3">
                                <label htmlFor="receipt_date">
                                  วันที่ออกรถ/ปล่อยรถ{" "}
                                </label>
                                <br />
                                <DatePicker
                                  type="text"
                                  className="form-control col-sm-12"
                                  name="car_issue_date"
                                  placeholder=""
                                  selected={this.state.car_issue_date}
                                  value={this.state.car_issue_date}
                                  onChange={this.handleCarIssueDate}
                                  dateFormat="yyyy-MM-dd"
                                />
                              </div>
                            </>
                          ) : null}

                          <div
                            className={
                              checkFormControls("date_promise", form_controls)
                                ? "form-group col-sm-3"
                                : "hidden"
                            }
                          >
                            <label htmlFor="date_promise">
                              วันที่ทำสัญญา/นัด{" "}
                            </label>{" "}
                            <br />
                            <DatePicker
                              selected={this.state.startDatePromise}
                              onChange={this.handleDatePromise}
                              dateFormat="yyyy-MM-dd"
                              type="text"
                              className="form-control"
                              id="date_promise"
                              name="date_promise"
                              placeholder=""
                            />
                          </div>

                          <div
                            className={
                              checkFormControls(
                                "car_transfer_date",
                                form_controls
                              )
                                ? "form-group col-sm-3"
                                : "hidden"
                            }
                          >
                            <label htmlFor="car_transfer_date">
                              วันที่โอนรถ/รับรถ{" "}
                            </label>{" "}
                            <br />
                            <DatePicker
                              selected={this.state.car_transfer_date}
                              onChange={this.handleCarDateTransfer}
                              dateFormat="yyyy-MM-dd"
                              type="text"
                              className="form-control"
                              id="car_transfer_date"
                              name="car_transfer_date"
                              placeholder=""
                            />
                          </div>

                          <div
                            className={
                              checkFormControls(
                                "finance_payment_date",
                                form_controls
                              ) && PORT !== 9043
                                ? "form-group col-sm-3"
                                : "hidden"
                            }
                          >
                            <label htmlFor="finance_payment_date">
                              วันที่รับเงิน(ไฟแนนซ์){" "}
                            </label>{" "}
                            <br />
                            <DatePicker
                              selected={this.state.finance_payment_date}
                              onChange={this.handleFinancePaymentDate}
                              dateFormat="yyyy-MM-dd"
                              type="text"
                              className="form-control"
                              id="finance_payment_date"
                              name="finance_payment_date"
                              placeholder=""
                            />
                          </div>

                          {port === 9046 ? (
                            <>
                              <div className="form-group col-sm-3">
                                <label htmlFor="more_detail_id">
                                  รายละเอียดเพิ่มเติม
                                </label>
                                <select
                                  className="form-control"
                                  id="more_detail_id"
                                  name="more_detail_id"
                                  ref="more_detail_id"
                                >
                                  <option value=" ">เลือกรายการ</option>
                                  {more_detail_list}
                                </select>
                              </div>
                            </>
                          ) : null}
                        </div>

                        <div className="row">
                          <hr
                            style={{ width: "100%", height: 1, color: "#000" }}
                          />
                        </div>
                        {/*pisan*/}
                        <div className="row">
                          <div className="form-group col-sm-3">
                            <label htmlFor="insurance_pa">
                              ค่างวดรถต่อเดือน
                            </label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="monthly_installment"
                              name="monthly_installment"
                              placeholder=""
                              value={this.state.monthly_installment}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              disabled={this.state.car_sell_type_id === "1"}
                              onValueChange={(values) =>
                                this.setState({
                                  monthly_installment: values.floatValue,
                                })
                              }
                            />
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="insurance_pa">รวมยอดผ่อน</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="total_installment"
                              name="total_installment"
                              placeholder=""
                              value={this.state.total_installment}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"฿"}
                              min={0}
                              max={1000000000}
                              step={1000}
                              size={10}
                              allowNegative={false}
                              disabled={this.state.car_sell_type_id === "1"}
                              onValueChange={(values) =>
                                this.setState({
                                  total_installment: values.floatValue,
                                })
                              }
                            />
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="first_installment">
                              งวดแรก(วันที่)
                            </label>
                            <br />
                            <DatePicker
                              type="text"
                              className="form-control col-sm-12"
                              name="first_installment"
                              placeholder=""
                              selected={this.state.first_installment}
                              value={this.state.first_installment}
                              onChange={this.handleFistInstallmentDate}
                              dateFormat="yyy-MM-dd"
                            />
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="insurance_pa">ดอกเบี้ยต่อปี</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="interest_installment"
                              name="interest_installment"
                              placeholder=""
                              value={this.state.interest_installment}
                              onChange={() => {}}
                            />
                            <NumberFormat
                              className="form-control"
                              thousandSeparator={true}
                              prefix={"%"}
                              min={0}
                              max={100}
                              step={0.1}
                              size={3}
                              allowNegative={false}
                              disabled={this.state.car_sell_type_id === "1"}
                              onValueChange={(values) =>
                                this.setState({
                                  interest_installment: values.floatValue,
                                })
                              }
                            />
                          </div>

                          <div className="form-group col-sm-3">
                            <label htmlFor="liciense_status_id">
                              สถานะเล่มทะเบียน
                            </label>
                            <select
                              className="form-control"
                              name="liciense_status_id"
                              id="liciense_status_id"
                              ref="liciense_status_id"
                            >
                              {liciense_status}
                            </select>
                          </div>

                          {PORT !== 9048 ? (
                            <>
                              <div className="form-group col-sm-3">
                                <label htmlFor="receipt_date">
                                  วันที่ออกรถ/ปล่อยรถ{" "}
                                </label>
                                <br />
                                <DatePicker
                                  type="text"
                                  className="form-control col-sm-12"
                                  name="car_issue_date"
                                  placeholder=""
                                  selected={this.state.car_issue_date}
                                  value={this.state.car_issue_date}
                                  onChange={this.handleCarIssueDate}
                                  dateFormat="yyyy-MM-dd"
                                />
                              </div>
                            </>
                          ) : null}

                          {/* <div className="form-group col-sm-3">
                            &nbsp;
                          </div>*/}

                          <div className="form-group col-sm-2">
                            <label htmlFor="receipt_date">นายหน้า</label>
                            <input
                              type="text"
                              className="form-control hidden"
                              id="agent_id"
                              name="agent_id"
                              placeholder=""
                              value={this.state.agent_id}
                              disabled={false}
                              onChange={() => {}}
                            />
                            <input
                              type="text"
                              className="form-control"
                              placeholder=""
                              value={
                                this.state.agent_id !== ""
                                  ? this.state.agentSelected.agent_fullname
                                  : ""
                              }
                              disabled={true}
                              onChange={() => {}}
                            />
                          </div>

                          <div className="form-group col-sm-1">
                            <label
                              style={{ color: "#ffffff" }}
                              htmlFor="agent_find"
                            >
                              &nbsp;&nbsp; x{" "}
                            </label>
                            {width >= 1161 ? (
                              <>
                                <br />{" "}
                              </>
                            ) : null}

                            <button
                              className="btn btn-secondary"
                              name="agent_find"
                              type="button"
                              style={styles.buttonHeight}
                              onClick={() => this.toggleAgentModal(true, null)}
                            >
                              <i className="icon-magnifier" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="row"
                      style={
                        checkGroupPermission(802, this.state.grouppermissions)
                          .created
                          ? styles.bottomLineAndMargin
                          : { display: "none" }
                      }
                    >
                      <div className="form-inline col-sm-12">
                        <u>
                          <h6>ค่าใช้จ่ายการขาย (บันทึกกรณีจ่ายแล้ว)</h6>
                        </u>
                        <span className="ml-1 text-danger">
                          **ทางเต็นท์รับผิดชอบ ไม่ได้เก็บกับลูกค้าเพิ่ม**
                        </span>
                      </div>

                      <div
                        className={
                          checkFormControls(
                            "car_external_commission",
                            form_controls
                          )
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="car_external_commission">
                          ค่านายหน้า
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="car_external_commission"
                          name="car_external_commission"
                          placeholder=""
                          ref="car_external_commission"
                          value={this.state.car_external_commission}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              car_external_commission: value,
                            });
                          }}
                        />
                      </div>

                      <div
                        className={
                          checkFormControls("sales_commission", form_controls)
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="sales_commission">
                          ค่าคอมมิชชั่นฝ่ายขาย
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="sales_commission"
                          name="sales_commission"
                          placeholder=""
                          ref="sales_commission"
                          value={this.state.sales_commission}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              sales_commission: value,
                            });
                          }}
                        />
                      </div>

                      <div
                        className={
                          checkFormControls(
                            "additional_commission",
                            form_controls
                          )
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="additional_commission">
                          {getFormControlName(
                            "additional_commission",
                            form_controls
                          )}
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="additional_commission"
                          name="additional_commission"
                          placeholder=""
                          ref="additional_commission"
                          value={this.state.additional_commission}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              additional_commission: value,
                            });
                          }}
                        />
                      </div>

                      <div
                        className={
                          checkFormControls("advertising_cost", form_controls)
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="additional_commission">{PORT === 9043 ? 'ค่าแอบแฝง' : 'ค่าโฆษณา'}</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="advertising_cost"
                          name="advertising_cost"
                          placeholder=""
                          ref="advertising_cost"
                          value={this.state.advertising_cost}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              advertising_cost: value,
                            });
                          }}
                        />
                      </div>

                      <div
                        className={
                          checkFormControls("delivery_fee", form_controls)
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="delivery_fee">ค่าบริการส่งรถ</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="delivery_fee"
                          name="delivery_fee"
                          placeholder=""
                          ref="delivery_fee"
                          value={this.state.delivery_fee}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              delivery_fee: value,
                            });
                          }}
                        />
                      </div>

                      <div
                        className={
                          checkFormControls("promotion_fee", form_controls)
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="promotion_fee">ค่าโปรโมชั่น</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="promotion_fee"
                          name="promotion_fee"
                          placeholder=""
                          ref="promotion_fee"
                          value={this.state.promotion_fee}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              promotion_fee: value,
                            });
                          }}
                        />
                      </div>

                      <div
                        className={
                          checkFormControls("finance_fee", form_controls)
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="finance_fee">ค่าธรรมเนียมไฟแนนท์</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="finance_fee"
                          name="finance_fee"
                          placeholder=""
                          ref="finance_fee"
                          value={this.state.finance_fee}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              finance_fee: value,
                            });
                          }}
                        />
                      </div>

                      <div
                        className={
                          checkFormControls("transfer_fee", form_controls)
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="transfer_fee">ค่าโอนรถ</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="transfer_fee"
                          name="transfer_fee"
                          placeholder=""
                          ref="transfer_fee"
                          value={this.state.transfer_fee}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              transfer_fee: value,
                            });
                          }}
                        />
                      </div>

                      <div
                        className={
                          checkFormControls("cost_phra", form_controls)
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label htmlFor="cost_phra">พระ</label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="cost_phra"
                          name="cost_phra"
                          placeholder=""
                          value={this.state.cost_phra}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              cost_phra: value,
                            });
                          }}
                        />
                      </div>

                      {/*<div
                          className={checkFormControls('cost_after_sales_service', form_controls)? "form-group col-sm-2" : "hidden"}
                      >
                        <label htmlFor="cost_after_sales_service" style={{fontSize: 12}} >บริการหลังการขาย</label>
                        <input type="text"
                               className="form-control hidden"
                               id="cost_after_sales_service"
                               name="cost_after_sales_service"
                               placeholder=""
                               value={this.state.cost_after_sales_service}
                               onChange={()=>{}}
                        />
                        <NumberFormat
                            className="form-control"
                            thousandSeparator={true}
                            prefix={'฿'}
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            onValueChange={(values) => {
                              const {value} = values
                              this.setState({
                                cost_after_sales_service: value
                              })
                            }}
                        />
                      </div>*/}

                      {this.renderInput(
                        "cost_after_sales_service",
                        "บริการหลังการขาย",
                        form_controls
                      )}

                      <div
                        className={
                          checkFormControls(
                            "cost_vat_and_property_tax",
                            form_controls
                          )
                            ? "form-group col-sm-2"
                            : "hidden"
                        }
                      >
                        <label
                          htmlFor="cost_vat_and_property_tax"
                          style={{ fontSize: 12 }}
                        >
                          ภาษีมูลค่าเพิ่ม + ภาษีโรงเรือน
                        </label>
                        <input
                          type="text"
                          className="form-control hidden"
                          id="cost_vat_and_property_tax"
                          name="cost_vat_and_property_tax"
                          placeholder=""
                          value={this.state.cost_vat_and_property_tax}
                          onChange={() => {}}
                        />
                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              cost_vat_and_property_tax: value,
                            });
                          }}
                        />
                      </div>

                      {this.state.car_status_id === 23 && (
                        <div
                          className={
                            checkFormControls(
                              "transfer_fee_estimate",
                              form_controls
                            )
                              ? "form-group col-sm-2"
                              : "hidden"
                          }
                        >
                          <label
                            htmlFor="transfer_fee_estimate"
                            style={{ fontSize: 12 }}
                          >
                            ประมาณการค่าโอน
                          </label>
                          <NumberFormat
                            className="form-control"
                            thousandSeparator={true}
                            prefix={"฿"}
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.transfer_fee_estimate}
                            onValueChange={(values) => {
                              const { value } = values;
                              this.setState({
                                transfer_fee_estimate: value,
                              });
                            }}
                          />
                        </div>
                      )}
                    </div>

                    <div
                      className="row"
                      style={
                        checkGroupPermission(803, this.state.grouppermissions)
                          .created
                          ? styles.bottomLineAndMargin
                          : { display: "none" }
                      }
                    >
                      <div className="form-inline col-sm-12">
                        <u>
                          <h6>ค่าใช้จ่ายจากไฟแนนซ์ (บันทึกกรณีจ่ายแล้ว) </h6>
                        </u>
                        <span className="ml-1 text-danger">
                          **ค่าใช้จ่ายที่จ่ายให้กับไฟแนนซ์**
                        </span>
                        {/*<span className="ml-1 text-danger"></span>*/}
                      </div>

                      {this.renderInput("finance_pa", "ประกันชีวิต PA", form_controls)}
                      {this.renderInput(
                        "finance_car_insurance",
                        "ประกันรถยนต์",
                        form_controls
                      )}
                      {this.renderInput(
                        "finance_ew",
                        "EW ประกันเครื่องยนต์",
                        form_controls
                      )}
                      {this.renderInput(
                        "finance_pay_advance",
                        "ค่างวดล่วงหน้า",
                        form_controls
                      )}
                      {this.renderInput(
                        "finance_health_insurance",
                        "ประกันสุขภาพ",
                        form_controls
                      )}
                      {this.renderInput(
                        "finance_document_fee",
                        "ค่าเอกสาร",
                        form_controls
                      )}
                      {this.renderInput(
                        "finance_transfer_fee",
                        "ค่าโอนจากไฟแนนซ์",
                        form_controls
                      )}
                      {this.renderInput(
                        "finance_stamp_fee",
                          PORT === 9072 ? "ยอดหักรวมจากไฟแนนซ์" : "ค่าอากร",
                        form_controls
                      )}
                    </div>

                    {/*{
                      checkGroupPermission(801, this.state.grouppermissions).viewed
                      // vat ยอดจัดได้คืน
                    }*/}

                    <div
                      className="row"
                      style={
                        checkGroupPermission(801, this.state.grouppermissions)
                          .created
                          ? styles.bottomLineAndMargin
                          : { display: "none" }
                      }
                    >
                      <div className="form-inline col-sm-12">
                        <u>
                          <h6>รายรับการขาย (บันทึกตามใบกำกับของไฟแนนซ์)</h6>
                        </u>
                        <span className="ml-1 text-danger">
                          **ยอดจัด/ค่าคอมมิชชั่น ดึงค่าจากการออกใบกำกับ**
                        </span>
                      </div>

                      {this.renderInput(
                        "tax_invoice_amount",
                        tax_invoice_amount_label,
                        form_controls
                      )}
                      {this.renderInputWithCalVatFinance(
                        "tax_invoice_vat",
                        tax_invoice_vat_label,
                        form_controls
                      )}

                      {this.renderInput(
                        "vat_sell",
                        "VAT ยอดจัดได้คืน",
                        form_controls
                      )}

                      {/*{this.renderInput('tax_commission_amount', 'ค่าคอมมิชชั่นไฟแนนท์', form_controls)}*/}

                      <div
                        className={
                          checkFormControls(
                            "tax_commission_amount",
                            form_controls
                          )
                            ? "form-group col-sm-3"
                            : "hidden"
                        }
                      >
                        <div className="form-inline pt-2 pb-1">
                          <label
                            htmlFor="tax_commission_amount"
                            style={{ fontSize: 14 }}
                          >
                            ค่าคอมมิชชั่นไฟแนนท์{" "}
                          </label>
                          &nbsp;&nbsp; | &nbsp;&nbsp;
                          <input
                            type="checkbox"
                            name="is_no_commission"
                            value={this.state.is_no_commission}
                            checked={this.state.is_no_commission === 1}
                            onChange={(e) => {
                              let val = Number(e.target.value) === 0 ? 1 : 0;

                              if (val === 1) {
                                // 0 =  ไม่ระบุ / มี com , 1 = ไม่มี com
                                this.setState({
                                  is_no_commission: val,
                                  tax_commission_amount: 0,
                                  tax_commission_vat: 0,
                                });
                              } else {
                                this.setState({
                                  is_no_commission: val,
                                });
                              }
                            }}
                          />
                          &nbsp;
                          <span style={{ fontSize: 14 }}>ไม่มีคอมฯ </span>
                        </div>

                        <NumberFormat
                          className="form-control"
                          thousandSeparator={true}
                          displayType="input"
                          prefix={"฿"}
                          min={0}
                          max={1000000000}
                          step={1000}
                          size={10}
                          allowNegative={false}
                          disabled={this.state.is_no_commission === 1}
                          value={this.state.tax_commission_amount}
                          onValueChange={(values) => {
                            const { value } = values;
                            this.setState({
                              tax_commission_amount: value,
                            });
                          }}
                        />
                      </div>

                      {this.renderInputWithCalVatCommission(
                        "tax_commission_vat",
                        "VAT คอมมิชชั่น",
                        form_controls
                      )}
                    </div>

                    <div className="row mt-2">
                      <div className="form-group col-sm-12">
                        <label htmlFor="sell_comment">หมายเหตุการขาย</label>
                        <ReactQuill
                          theme="snow"
                          value={this.state.sell_comment}
                          onChange={(val) => {
                            this.setState({
                              sell_comment: val,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header">
                    <strong className="text-title">
                      การชำระเงิน (หากลูกค้าชำระเงินแล้วกรุณา บันทึกการชำระเงิน)
                    </strong>

                    {checkGroupPermission(806, this.state.grouppermissions)
                      .created ? (
                      <Button
                        type="button"
                        onClick={this.carSellPayAdd}
                        className="btn btn-info float-right"
                      >
                        <i className="icon-plus" />
                        &nbsp;&nbsp;เพิ่มการชำระเงิน
                      </Button>
                    ) : null}
                  </div>

                  <table className="table table-bordered table-striped table-md">
                    <thead>
                      <tr>
                        <th className="text-center" width="18%">
                          วันที่ / เลขเอกสาร
                        </th>
                        <th className="text-center" width="18%">
                          รายการ
                        </th>
                        <th className="text-center" width="15%">
                          จำนวนเงินที่ชำระ
                        </th>
                        <th className="text-center" width="20%">
                          ชำระโดย/ธนาคาร
                        </th>
                        <th className="text-center" width="18%">
                          แนบสลิป
                        </th>
                        <th className="text-center">ผู้บันทึก</th>
                        <th className="text-center" width="5%">
                          จัดการ
                        </th>
                      </tr>
                    </thead>
                    <tbody>{car_sell_pay_tr}</tbody>
                  </table>

                  <div className="card-footer text-right">
                    <button
                      type="reset"
                      className="btn btn-sm btn-danger mr-2"
                      //onClick={this.props.onToggle}
                    >
                      <i className="fa fa-refresh" /> ยกเลิก
                    </button>
                    <button type="submit" className="btn btn-sm btn-primary">
                      <i className="fa fa-save" /> บันทึกการขาย
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <Modal
          isOpen={this.state.toggle_pay_add}
          toggle={this.toggleCarSellPayAdd}
          className={"modal-lg " + this.props.className}
          style={width <= 980 ? { maxWidth: 800 } : { maxWidth: 1200 }}
        >
          <ModalBody>
            <form
              action=""
              method="post"
              onSubmit={this.handleCarSellPayAddSubmit}
            >
              <div className="card card-accent-info">
                <div className="card-header">
                  <strong className="text-title">เพิ่มการชำระเงิน</strong>
                </div>
                <div className="card-block">
                  <div className="row">
                    {/*เพิ่ม--ปรับใบเสร็จของ kmhomecar thadyon 7-4-66*/}
                    {/*ปรับให้ใช้ทุกเต็นท์ 12-10-66*/}
                    <div className="form-group col-12">
                      <strong>ประเภท</strong>
                      &nbsp;&nbsp;
                      <input
                        type="radio"
                        name="receipt_type"
                        value="ออกใบเสร็จรับเงิน"
                        className="btn btn-primary ml-3"
                        //defaultChecked={this.state.receipt_type === 'ออกใบเสร็จรับเงิน'}
                        checked={
                          this.state.receipt_type === "ออกใบเสร็จรับเงิน"
                        }
                        onChange={() => {
                          let doc_type = "RE";
                          let receipt_type = "ออกใบเสร็จรับเงิน";
                          const doc_config = getDocTypeConfig(
                            this.state.company_setting,
                            doc_type
                          );
                          this.setState({
                            doc_type,
                            receipt_type,
                            doc_config,
                          });
                        }}
                      />{" "}
                      &nbsp;
                      <span style={{ marginTop: 0 }}>
                        {" "}
                        <strong>ออกใบเสร็จรับเงิน</strong>
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      {this.state.is_vat === 1 ? (
                        <>
                          <input
                            type="radio"
                            name="receipt_type"
                            value="ออกใบกำกับภาษี"
                            className="btn btn-primary ml-3"
                            checked={
                              this.state.receipt_type === "ออกใบกำกับภาษี"
                            }
                            onChange={() => {
                              let doc_type = "RT";
                              let receipt_type = "ออกใบกำกับภาษี";
                              const doc_config = getDocTypeConfig(
                                this.state.company_setting,
                                doc_type
                              );
                              this.setState({
                                doc_type,
                                receipt_type,
                                doc_config,
                              });
                            }}
                          />{" "}
                          &nbsp;
                          <span style={{ marginTop: 0 }}>
                            {" "}
                            <strong>ออกใบกำกับภาษี</strong>
                          </span>
                        </>
                      ) : null}
                    </div>

                    <div
                      className={
                        this.state.doc_config === "manual"
                          ? "form-group col-md-3"
                          : "form-group col-6"
                      }
                    >
                      <label htmlFor="date_pay">วันที่ชำระเงิน </label>
                      <br />
                      <DatePicker
                        selected={this.state.date_pay}
                        onChange={this.handleDatePay}
                        dateFormat="yyyy-MM-dd"
                        type="text"
                        className="form-control"
                        id="date_pay"
                        name="date_pay"
                        placeholder="วันที่ชำระเงิน"
                      />
                    </div>

                    <div
                      className={
                        this.state.doc_config === "manual"
                          ? "form-group col-3 "
                          : "form-group col-3 hidden"
                      }
                    >
                      <label htmlFor="doc_no">
                        {" "}
                        เลขเอกสาร &nbsp;{" "}
                        {this.state.check_doc_no === "repeat" ? "ซ้ำ" : ""}
                      </label>
                      <input
                        type="text"
                        style={{
                          ...styles.inputDataNum,
                          borderColor: setInputStyleDocNo(
                            this.state.check_doc_no
                          ),
                        }}
                        className="form-control"
                        placeholder="เลขเอกสาร"
                        name="doc_no"
                        maxLength={20}
                        value={this.state.doc_no}
                        onChange={(e) => {
                          this.setState({
                            doc_no: e.target.value,
                            check_doc_no: "noset",
                          });
                        }}
                        onBlur={(e) => {
                          this.checkTaxInvoiceNumberRepeat();
                        }}
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label htmlFor="car_repair_complete">รายการ </label>
                      <select
                        className="form-control"
                        id="car_sell_list_pay_id"
                        ref="car_sell_list_pay_id"
                        value={this.state.car_sell_list_pay_id}
                        onChange={(e) => {
                          const { target } = e;
                          if (Number(target.value) === 7) {
                            this.setState({
                              car_sell_list_pay_id: Number(target.value),
                              is_vat: 0,
                            });
                          } else {
                            this.setState(
                              {
                                car_sell_list_pay_id: Number(target.value),
                              },
                              async () => {
                                if (
                                  this.state.is_vat === 0 &&
                                  target.value !== ""
                                ) {
                                  await this.loadCompanySetting();
                                }
                              }
                            );
                          }
                        }}
                      >
                        <option value="">เลือกรายการ</option>
                        {car_sell_list_pay_list}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div
                      className={
                        this.state.is_vat === 1
                          ? "form-group col-md-6"
                          : "form-group col-md-6"
                      }
                    >
                      <label htmlFor="car_sell_pay_count">
                        จำนวนเงินที่ชำระ &nbsp;&nbsp;
                        {this.state.is_vat === 1 ? (
                          <>
                            {this.state.is_vat === 1
                              ? this.state.include_vat === 1
                                ? " *รวม vat "
                                : " *ไม่รวม vat "
                              : null}

                            <Switch
                              height={20}
                              width={48}
                              onChange={(checked) => {
                                let car_sell_list_pay_id =
                                  this.state.car_sell_list_pay_id;
                                if (car_sell_list_pay_id === 7) {
                                  return;
                                }

                                if (checked === false) {
                                  this.setState({ include_vat: 0 });
                                } else {
                                  this.setState({ include_vat: 1 });
                                }
                              }}
                              checked={this.state.include_vat === 1}
                            />
                          </>
                        ) : null}
                      </label>
                      <input
                        type="text"
                        className="form-control hidden"
                        id="car_sell_pay_count"
                        name="car_sell_pay_count"
                        placeholder=""
                        ref="car_sell_pay_count"
                        value={this.state.car_sell_pay_count}
                        onChange={() => {}}
                      />
                      <NumberFormat
                        className="form-control"
                        thousandSeparator={true}
                        prefix={"฿"}
                        //placeholder="กรอกค่าโอน"
                        min={0}
                        max={1000000000}
                        step={1000}
                        size={10}
                        allowNegative={false}
                        value={this.state.car_sell_pay_count}
                        onValueChange={(values) => {
                          const { value } = values;
                          this.setState(
                            { car_sell_pay_count: value },
                            () => {}
                          );
                        }}
                      />

                      <input
                        type="text hidden"
                        className="form-control hidden"
                        id="car_sell_pay_count_old"
                        name="car_sell_pay_count_old"
                        placeholder=""
                        ref="car_sell_pay_count_old"
                        value={this.state.car_sell_pay_count_old}
                        onChange={() => {}}
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label htmlFor="car_sell_pay_count">ประเภทการชำระ </label>
                      <select
                        className="form-control"
                        id="sales_type_id"
                        ref="sales_type_id"
                        value={this.state.sales_type_id}
                        onChange={this.carSalesPayTypeChange.bind(this)}
                      >
                        <option value="">เลือกประเภทการรับชำระ</option>
                        {sales_type_list}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="bank_id">ธนาคาร </label>
                      <select
                        className="form-control"
                        id="bank_id"
                        name="bank_id"
                        ref="bank_id"
                        value={this.state.bank_id}
                        onChange={(e) => {
                          const { target } = e;
                          this.setState({
                            bank_id: target.value,
                          });
                        }}
                      >
                        <option value="">เลือกธนาคาร</option>
                        {bank_pay_list}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="card-footer text-right">
                  <button
                    type="reset"
                    onClick={() => {
                      this.setState({
                        toggle_pay_add: false,
                      });
                    }}
                    className="btn btn-sm btn-danger mr-2"
                  >
                    <i className="fa fa-refresh" /> ยกเลิก
                  </button>

                  <button type="submit" className="btn btn-sm btn-primary">
                    <i className="fa fa-plus" /> เพิ่มชำระเงิน
                  </button>

                  <input
                    type="hidden"
                    id="car_sell_pay_id"
                    name="car_sell_pay_id"
                    value={this.state.car_sell_pay_id}
                  />
                </div>
              </div>
            </form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const styles = {
  bottomLine: {
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
    borderWidth: 0.5,
  },
  bottomLineAndMargin: {
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
    borderWidth: 0.5,
    paddingTop: 8,
  },
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  type: state.auth.type,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(SalesBuy);
